// import { Component, OnInit, Renderer2, ElementRef, NgZone, Input, ViewChild, SecurityContext, AfterViewChecked, AfterViewInit } from "@angular/core"
// import { FormBuilder, FormGroup, Validators } from "@angular/forms"
// import { ChatMessage, ChatService, ChatSession, Chat } from "../../services/chat.service"
// import { AuthService } from "../../services/auth.service"
// import { ThemeService } from "../../theme.service"
// import { ActivatedRoute, Router } from '@angular/router';
// import { DomSanitizer, SafeHtml } from "@angular/platform-browser"
// import Swal from 'sweetalert2';
// import { formatDate } from "@angular/common"
// import { Subscription } from 'rxjs';

// declare global {
//   interface Window {
//     MathJax: any;
//   }
// }
// // interface ChatMessage {
// //   content: string
// //   sender: "user" | "ai"
// //   timestamp: Date
// //   status?: "sent" | "read"
// // }
// declare global {
//   interface Window {
//     webkitSpeechRecognition: any
//   }
// }
// @Component({
//   selector: 'app-chat',
//   templateUrl: './chat.component.html',
//   template: `<div [innerHTML]="formattedMessage"></div>`,
//   styleUrls: ['./chat.component.css']
// })
// export class ChatComponent implements AfterViewChecked {
//   sessionId: any
//     // sessionId: string | undefined

//     | undefined
//   autoScrollEnabled: boolean = true
//   user: any
//   isMoved = false;
//   isRevealing = false;
//   currentTheme: string = 'default';
//   themeApplied: any
//   isLightTheme: boolean | undefined
//   pinnedSessions: any
//   greetingIcon: string | undefined
//   // chatId: string | null
//   // groupedMessages: { label: string, messages: any[] }[] = [];
//   isProgrammaticScroll = false;
//   groupedMessages: any;
//   chatSession: ChatSession | null = null;
//   subscription!: Subscription;
//   audio = new Audio();
//   playingMessageUrl: string | null = null;
//   classToCollectionMap: { [key: string]: string } = {
//     '1': 'irish_1st_collection',
//     '2': 'irish_2nd_collection',
//     '3': 'irish_3rd_collection',
//     '4': 'irish_4th_collection',
//     '5': 'irish_5th_collection',
//     '6': 'irish_6th_collection',
//     '7': 'irish_7th_collection',
//     '8': 'irish_8th_collection',
//     '9': 'irish_9th_collection',
//     '10': 'irish_10th_collection',
//     '11': 'irish_11th_collection',
//     '12': 'irish_12th_collection',
//     '13': 'irish_test_collection',
//   };
//   setTheme(theme: string) {
//     this.currentTheme = theme;
//   }
//   // sessionId: string | undefined
//   @Input() set selectedChat(chat: ChatSession | null) {
//     console.log("Selected Chat:", chat); // Log the incoming chat data

//     this._selectedChat = chat;

//     if (chat) {
//       this.messages = this.convertChatsToMessages(chat.chats || []);

//       console.log("Converted Messages:", this.messages); // Log the converted messages
//     } else {
//       this.messages = [];
//     }
//   }

//   get selectedChat(): ChatSession | null {
//     return this._selectedChat;
//   }

//   @ViewChild("chatContent") private chatContent!: ElementRef

//   playingMessageText: string | null = null;
//   private shouldScroll: boolean = false;
//   private _selectedChat: any;
//   chatForm: FormGroup
//   messages: ChatMessage[] = []
//   isTyping = false
//   maxLength = 1000
//   userName = "John"
//   userImageUrl = "../../assets/user-avatar.jpg"
//   currentAudio: HTMLAudioElement | null = null
//   displayedMessage = ""
//   fullMessage = ""
//   wordIndex = 0
//   revealInterval: any
//   accentColor = "#e60f0f";
//   primaryColor = "#c2c4c7"
//   themeColor: string = '';
//   isPlayingAudio = false
//   audioError = false
//   isSidebarOpen = false
//   isListening = false
//   recognition: any
//   greetingMessage: string = '';
//   suggestionChips: any;


//   constructor(
//     private fb: FormBuilder,
//     private chatService: ChatService,
//     private authService: AuthService,
//     private sanitizer: DomSanitizer,
//     private themeService: ThemeService,
//     private renderer: Renderer2,
//     private el: ElementRef,
//     private ngZone: NgZone,
//     private route: ActivatedRoute,  // ✅ Inject ActivatedRoute correctly
//     private router: Router
//   ) {
//     this.chatForm = this.fb.group({
//       message: ["", [Validators.required, Validators.maxLength(this.maxLength)]],
//     })
//   }

//   ngOnInit(): void {
//     // this.chatId = this.route.snapshot.paramMap.get('id');
//     this.sessionId = null;
//     this.user = this.authService.getUser();
//     console.log(this.user, 'user details')
//     this.sessionId = this.route.snapshot.paramMap.get('id');
//     this.route.paramMap.subscribe(params => {
//       this.sessionId = params.get('id');
//       console.log('Chat ID:', this.sessionId);
//       // this.sendMessage();
//       if (this.sessionId) {
//         this.loadChatMessages(this.sessionId);
//       }

//     });
//     console.log(this.sessionId, '  this.sessionId')

//     this.subscription = this.chatService.currentChat$.subscribe((chat) => {
//       this.chatSession = chat;

//       if (!chat) {
//         this.clearChat(); // New chat requested
//       }
//     });

//     // console.log( this.user.user,'User')
//     // this.getPiinedSesion();
//     this.initSpeechRecognition()
//     this.applyTheme();
//     this.groupMessagesByDate();

//     // const savedTheme = localStorage.getItem('theme') === 'dark'; // Check if the saved theme is dark
//     // this.themeService.isDarkMode$.next(savedTheme); // Update BehaviorSubject with saved theme

//     // this.applyTheme(savedTheme); // Apply theme immediately

//     // console.log('theme:', savedTheme); // Debugging

//     // Listen for theme changes and apply them dynamically
//     // this.themeService.isDarkMode$.subscribe((isDarkMode) => {
//     //   this.applyTheme();
//     // });
//     this.updateIconsByTheme();
//     this.initializeSuggestionChips();
//   }
//   loadChat(chat: ChatSession) {
//     console.log('Loading chat:', chat);
//     // Load messages logic
//   }

//   clearChat() {
//     this._selectedChat = null;
//     this.messages = [];
//     this.groupedMessages = {};
//   }

//   ngOnDestroy() {
//     this.subscription.unsubscribe();
//   }
//   initializeSuggestionChips(): void {
//     this.suggestionChips = [
//       {
//         label: this.user.user.questions[0].questions,
//         icon: 'assets/icon/Default_theme/Default_1.svg',
//         customSvgPath: `M0.415186 11.053C0.736749...`,
//         iconSvg: this.sanitizer.bypassSecurityTrustHtml(`
//           <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path  fill="${this.themeColor || '#000'}" d="M0.415186 11.053C0.736749 11.6113 1.50217 11.8965 2.58791 11.8965C3.24116 11.8965 4.01511 11.7876 4.87252 11.5784C5.43052 13.7246 6.39518 15 7.4781 15C7.67313 15 7.86941 14.9582 8.06394 14.8746C8.09931 14.859 8.9285 14.4835 9.38058 13.4693C9.63006 13.0092 9.84514 12.4481 10.0253 11.8085C10.9405 12.0772 11.747 12.2124 12.4134 12.2124C13.3096 12.2123 13.9544 11.9708 14.277 11.4913C14.5436 11.0951 14.5532 10.5655 14.3126 9.95304C14.5777 9.74516 14.75 9.43755 14.75 9.08998C14.75 8.46419 14.2055 7.95515 13.536 7.95515C13.3501 7.95515 13.1759 7.99778 13.0183 8.06818C12.8946 7.93488 12.7622 7.79966 12.6212 7.66239C14.3593 6.18685 15.062 4.8382 14.546 3.94242C14.3933 3.67608 14.136 3.47424 13.7912 3.33274C13.7854 2.72322 13.2539 2.2287 12.6004 2.2287C12.0068 2.2287 11.5174 2.63769 11.4276 3.16928C11.0107 3.22024 10.563 3.30392 10.0906 3.41944C9.53228 1.27446 8.56521 0 7.4781 0C6.42583 0 5.50625 1.16077 4.93428 3.19143C2.79087 2.56259 1.24989 2.67226 0.689175 3.50671C0.4563 3.85471 0.417132 4.28976 0.56753 4.79964C0.373497 4.99788 0.252039 5.25933 0.252039 5.54858C0.252039 6.16285 0.786565 6.66258 1.44364 6.66258C1.52476 6.66258 1.60392 6.65469 1.68054 6.64019C1.88325 6.87399 2.10418 7.1078 2.34134 7.33884C0.603133 8.81681 -0.100051 10.1636 0.415186 11.053ZM5.30058 3.81121C5.85335 3.99618 6.42347 4.22322 7.00537 4.49172C6.67398 4.63775 6.34328 4.78992 6.01775 4.95398C5.67842 5.12552 5.3438 5.30951 5.01321 5.49819C5.07956 4.90308 5.17612 4.3391 5.30058 3.81121ZM9.7093 4.01562C9.81649 4.50664 9.90103 5.02615 9.96005 5.57126C9.69364 5.39887 9.41901 5.2263 9.12926 5.0549C8.81101 4.86758 8.49156 4.6943 8.17335 4.52837C8.6972 4.3265 9.21061 4.15585 9.7093 4.01562ZM9.66092 11.1889C9.10583 11.0034 8.53617 10.7768 7.95757 10.5101C8.29428 10.3613 8.62781 10.2073 8.95017 10.044C9.2918 9.8731 9.62409 9.69095 9.95026 9.50475C9.88399 10.0952 9.78675 10.6582 9.66092 11.1889ZM10.549 6.56617C11.0264 6.91479 11.4688 7.27382 11.8742 7.63867C11.4709 7.95723 11.0249 8.27357 10.5386 8.5841C10.5598 8.22439 10.5744 7.86185 10.5744 7.49767C10.5744 7.17708 10.5641 6.86817 10.549 6.56617ZM8.85701 5.45813C9.26863 5.70159 9.65583 5.94771 10.0156 6.19092C10.0467 6.60454 10.0643 7.04168 10.0643 7.49767C10.0643 7.97284 10.0435 8.44703 10.0065 8.91181C9.58998 9.16039 9.15553 9.40046 8.70831 9.62428C8.27985 9.84128 7.83399 10.045 7.38303 10.2343C6.9459 10.0167 6.51703 9.78664 6.10891 9.54629C5.70783 9.31067 5.31944 9.0626 4.9481 8.8094C4.91702 8.39292 4.89938 7.95411 4.89938 7.49767C4.89938 7.02486 4.92014 6.5531 4.95715 6.09058C5.38135 5.83872 5.81817 5.5969 6.2601 5.37362C6.69436 5.15469 7.13781 4.95277 7.58071 4.76786C8.00334 4.97767 8.43188 5.20785 8.85701 5.45813ZM4.41487 8.43392C3.93276 8.08227 3.49047 7.7235 3.08961 7.36178C3.49959 7.03901 3.94551 6.72286 4.42503 6.41727C4.40388 6.77495 4.38926 7.13546 4.38926 7.49767C4.38926 7.81927 4.39968 8.12988 4.41487 8.43392ZM5.83716 9.94987C6.14482 10.131 6.46558 10.3046 6.79052 10.4738C6.27159 10.6733 5.758 10.8433 5.25444 10.9845C5.14763 10.4948 5.06307 9.97597 5.00391 9.43098C5.27563 9.60797 5.55237 9.78248 5.83716 9.94987ZM8.92152 13.2613C8.91829 13.2668 8.91555 13.2725 8.91306 13.2784C8.54043 14.1214 7.85197 14.4409 7.84874 14.4424C7.72195 14.4968 7.60065 14.5232 7.4781 14.5232C6.66814 14.5232 5.84929 13.3241 5.36402 11.4515C6.01803 11.2697 6.68874 11.0399 7.36421 10.764C8.1039 11.1237 8.83396 11.4217 9.5413 11.6553C9.3675 12.2795 9.16053 12.8221 8.92152 13.2613ZM13.8451 11.2375C13.4255 11.8608 12.0177 11.8974 10.1466 11.3441C10.3092 10.671 10.4269 9.94718 10.4955 9.18478C11.139 8.79105 11.7221 8.38553 12.2369 7.97645C12.3713 8.10679 12.4972 8.235 12.615 8.36127C12.4364 8.55901 12.3245 8.81125 12.3245 9.08998C12.3245 9.71438 12.868 10.2224 13.536 10.2224C13.648 10.2224 13.7544 10.2036 13.8574 10.177C13.9838 10.5215 14.0518 10.9304 13.8451 11.2375ZM14.2399 9.08998C14.2399 9.45154 13.9241 9.74558 13.536 9.74558C13.1492 9.74558 12.8346 9.45154 12.8346 9.08998C12.8346 8.72715 13.1492 8.43194 13.536 8.43194C13.9241 8.43194 14.2399 8.72715 14.2399 9.08998ZM14.0967 4.16813C14.4771 4.82822 13.7574 6.05487 12.2606 7.32455C11.735 6.84877 11.1479 6.38306 10.5072 5.93669C10.4461 5.21247 10.3428 4.52507 10.2013 3.88512C10.6469 3.77557 11.0681 3.69549 11.4595 3.64614C11.6019 4.11231 12.0567 4.45658 12.6004 4.45658C13.0797 4.45658 13.4913 4.18918 13.6804 3.80688C13.8714 3.90037 14.012 4.02069 14.0967 4.16813ZM12.6004 2.70549C12.9763 2.70549 13.2822 2.99127 13.2822 3.34258C13.2822 3.69389 12.9763 3.97978 12.6004 3.97978C12.2246 3.97978 11.919 3.69389 11.919 3.34258C11.919 2.99127 12.2246 2.70549 12.6004 2.70549ZM7.4781 0.476797C8.29263 0.476797 9.11423 1.67595 9.59968 3.54862C8.95322 3.72864 8.28254 3.95917 7.59955 4.2382C6.85442 3.87582 6.12295 3.57688 5.41841 3.34423C5.91337 1.5707 6.69345 0.476797 7.4781 0.476797ZM0.762155 5.54858C0.762155 5.19727 1.06778 4.91138 1.44364 4.91138C1.8195 4.91138 2.12537 5.19727 2.12537 5.54858C2.12537 5.89989 1.8195 6.18578 1.44364 6.18578C1.06778 6.18578 0.762155 5.89989 0.762155 5.54858ZM1.44364 4.43458C1.29315 4.43458 1.15044 4.46355 1.01776 4.51135C0.956344 4.20824 0.990219 3.95583 1.12133 3.75989C1.53929 3.13794 2.9453 3.10296 4.81495 3.6559C4.65425 4.32443 4.53723 5.04888 4.46816 5.8173C3.83482 6.20339 3.25137 6.60852 2.72598 7.02472C2.52435 6.8291 2.33408 6.63176 2.15847 6.43429C2.44633 6.23074 2.63549 5.9112 2.63549 5.54858C2.63549 4.93431 2.10071 4.43458 1.44364 4.43458ZM2.70291 7.67561C3.22151 8.14636 3.80876 8.61209 4.45648 9.06327C4.51782 9.78876 4.62109 10.4764 4.76249 11.1154C2.76929 11.6042 1.25034 11.4972 0.864029 10.8266C0.479091 10.1617 1.18321 8.96418 2.70291 7.67561Z" fill="#471966"/>
// <path fill="${this.themeColor || '#000'}" d="M7.48169 8.71026C8.22644 8.71026 8.83221 8.14395 8.83221 7.44785C8.83221 6.75186 8.22644 6.18555 7.48169 6.18555C6.73694 6.18555 6.13118 6.75186 6.13118 7.44785C6.13118 8.14395 6.73694 8.71026 7.48169 8.71026ZM7.48169 6.66234C7.94498 6.66234 8.32209 7.0147 8.32209 7.44785C8.32209 7.88099 7.94498 8.23347 7.48169 8.23347C7.0184 8.23347 6.6413 7.88099 6.6413 7.44785C6.6413 7.0147 7.0184 6.66234 7.48169 6.66234Z" fill="#471966"/>
// </svg>

//         `)
//       },
//       {
//         label: this.user.user.questions[1].questions,
//         icon: 'assets/icon/Default_theme/Default_2.svg',
//         customSvgPath: 'M4 4h8v2H4V4zm0 4h8v2H4V8zm0 4h8v2H4v-2z',
//         iconSvg: this.sanitizer.bypassSecurityTrustHtml(`
//          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path fill="${this.themeColor || '#000'}" d="M12.2814 9.78762L11.1255 8.63178L9.96968 7.47593L8.81797 6.32163L2.85729 0.361472C2.82849 0.332635 2.79428 0.309759 2.75663 0.29415C2.71898 0.278542 2.67862 0.270508 2.63786 0.270508C2.5971 0.270508 2.55674 0.278542 2.51909 0.29415C2.48144 0.309759 2.44723 0.332635 2.41842 0.361472L0.225105 2.55479C0.167023 2.61295 0.134399 2.69178 0.134399 2.77397C0.134399 2.85616 0.167023 2.93499 0.225105 2.99314L12.1413 14.9093C12.1701 14.9382 12.2043 14.961 12.242 14.9767C12.2796 14.9923 12.32 15.0003 12.3607 15.0003C12.4015 15.0003 12.4418 14.9923 12.4795 14.9767C12.5171 14.961 12.5514 14.9382 12.5802 14.9093L14.773 12.716C14.831 12.6579 14.8637 12.579 14.8637 12.4968C14.8637 12.4146 14.831 12.3358 14.773 12.2777L12.2814 9.78762ZM12.3589 14.2513L0.883153 2.77552L2.6376 1.02107L3.53343 1.91639L2.65466 2.79516C2.59724 2.85345 2.56518 2.93207 2.56546 3.01389C2.56575 3.09572 2.59835 3.17411 2.65618 3.232C2.714 3.28989 2.79235 3.32259 2.87418 3.32297C2.956 3.32335 3.03465 3.29138 3.09301 3.23403L3.97179 2.35526L4.68928 3.07223L4.36052 3.40152C4.33004 3.42991 4.3056 3.46415 4.28865 3.5022C4.2717 3.54024 4.26258 3.58131 4.26185 3.62296C4.26111 3.6646 4.26877 3.70597 4.28437 3.74459C4.29997 3.78321 4.32319 3.81829 4.35264 3.84774C4.38209 3.8772 4.41718 3.90041 4.4558 3.91601C4.49442 3.93161 4.53578 3.93927 4.57743 3.93854C4.61907 3.9378 4.66014 3.92869 4.69819 3.91174C4.73623 3.89478 4.77048 3.87034 4.79887 3.83987L5.12815 3.51111L5.84513 4.2286L4.96635 5.10737C4.93719 5.13611 4.914 5.17033 4.89812 5.20807C4.88224 5.24581 4.874 5.28631 4.87385 5.32726C4.87371 5.3682 4.88168 5.40876 4.89729 5.44661C4.9129 5.48446 4.93586 5.51884 4.96482 5.54778C4.99379 5.57671 5.0282 5.59962 5.06607 5.61519C5.10394 5.63076 5.14451 5.63868 5.18545 5.63848C5.22639 5.63829 5.26689 5.63 5.30461 5.61408C5.34233 5.59816 5.37653 5.57493 5.40522 5.54573L6.284 4.66695L7.00098 5.38445L6.67221 5.71321C6.64339 5.74203 6.62054 5.77624 6.60494 5.81389C6.58934 5.85154 6.58132 5.89189 6.58132 5.93265C6.58132 5.9734 6.58934 6.01375 6.60494 6.0514C6.62054 6.08906 6.64339 6.12327 6.67221 6.15208C6.70103 6.1809 6.73524 6.20376 6.77289 6.21935C6.81054 6.23495 6.85089 6.24297 6.89165 6.24297C6.9324 6.24297 6.97275 6.23495 7.0104 6.21935C7.04805 6.20376 7.08226 6.1809 7.11108 6.15208L7.43985 5.8228L8.15734 6.54029L7.27856 7.41907C7.22115 7.47736 7.18909 7.55598 7.18937 7.6378C7.18966 7.71962 7.22226 7.79802 7.28008 7.85591C7.33791 7.9138 7.41626 7.9465 7.49808 7.94688C7.5799 7.94726 7.65856 7.91529 7.71692 7.85794L8.59569 6.97916L9.31319 7.69614L8.98442 8.02542C8.95395 8.05382 8.92951 8.08806 8.91256 8.1261C8.8956 8.16415 8.88649 8.20522 8.88576 8.24686C8.88502 8.28851 8.89268 8.32988 8.90828 8.36849C8.92388 8.40711 8.9471 8.4422 8.97655 8.47165C9.006 8.5011 9.04108 8.52432 9.0797 8.53992C9.11832 8.55552 9.15969 8.56318 9.20133 8.56244C9.24298 8.56171 9.28405 8.5526 9.32209 8.53564C9.36014 8.51869 9.39438 8.49425 9.42278 8.46378L9.75154 8.13501L10.469 8.8525L9.59026 9.73128C9.56109 9.76001 9.5379 9.79423 9.52203 9.83197C9.50615 9.86971 9.4979 9.91022 9.49776 9.95116C9.49762 9.9921 9.50558 10.0327 9.5212 10.0705C9.53681 10.1084 9.55976 10.1427 9.58873 10.1717C9.6177 10.2006 9.65211 10.2235 9.68997 10.2391C9.72784 10.2547 9.76842 10.2626 9.80936 10.2624C9.8503 10.2622 9.8908 10.2539 9.92852 10.238C9.96624 10.2221 10.0004 10.1988 10.0291 10.1696L10.9079 9.29086L11.6249 10.0084L11.2961 10.3371C11.2379 10.3953 11.2052 10.4742 11.2052 10.5566C11.2052 10.6389 11.2379 10.7178 11.2961 10.776C11.3543 10.8342 11.4332 10.8669 11.5156 10.8669C11.5979 10.8669 11.6768 10.8342 11.735 10.776L12.0638 10.4467L12.7812 11.1642L11.9025 12.043C11.8451 12.1013 11.813 12.1799 11.8133 12.2617C11.8136 12.3435 11.8462 12.4219 11.904 12.4798C11.9618 12.5377 12.0402 12.5704 12.122 12.5708C12.2038 12.5712 12.2825 12.5392 12.3408 12.4818L13.2196 11.6031L14.1154 12.4984L12.3589 14.2513Z" fill="#471966"/>
// <path fill="${this.themeColor || '#000'}" d="M6.79175 10.4C6.7336 10.342 6.65477 10.3093 6.57258 10.3093C6.49039 10.3093 6.41156 10.342 6.3534 10.4L3.90731 12.8487L3.24977 12.1907L5.69794 9.742C5.75602 9.68385 5.78864 9.60501 5.78864 9.52282C5.78864 9.44063 5.75602 9.3618 5.69794 9.30365C5.66913 9.27481 5.63493 9.25193 5.59727 9.23632C5.55962 9.22072 5.51926 9.21268 5.4785 9.21268C5.43774 9.21268 5.39738 9.22072 5.35973 9.23632C5.32208 9.25193 5.28787 9.27481 5.25907 9.30365L2.8109 11.7518L2.14976 11.0943L4.59895 8.64767C4.6563 8.58931 4.68827 8.51065 4.68789 8.42883C4.68751 8.34701 4.65481 8.26865 4.59692 8.21083C4.53903 8.15301 4.46064 8.1204 4.37881 8.12012C4.29699 8.11983 4.21837 8.15189 4.16008 8.20931L1.49222 10.8767L1.48757 10.8823C1.48456 10.885 1.48179 10.888 1.4793 10.8911L1.46431 10.9097L1.45707 10.919C1.45191 10.9273 1.44674 10.9351 1.44208 10.9433L1.43898 10.949C1.43326 10.9594 1.42825 10.9701 1.42399 10.9811L0.024154 14.5665C0.00441301 14.6147 -0.00331365 14.667 0.00163902 14.7189C0.00659169 14.7707 0.0240755 14.8206 0.0525851 14.8642C0.0920344 14.9223 0.150022 14.9653 0.217066 14.9861C0.28411 15.007 0.356243 15.0045 0.42167 14.979L4.01741 13.576L4.02516 13.5729C4.03943 13.5665 4.05325 13.559 4.06652 13.5507L4.07686 13.5445C4.09171 13.5343 4.10571 13.5229 4.11873 13.5104L4.12235 13.5073L6.78969 10.84C6.81852 10.8111 6.8414 10.7769 6.85701 10.7393C6.87262 10.7016 6.88065 10.6613 6.88065 10.6205C6.88065 10.5798 6.87262 10.5394 6.85701 10.5017C6.8414 10.4641 6.81852 10.4299 6.78969 10.4011L6.79175 10.4ZM0.857439 14.1441L1.83081 11.6489L2.59173 12.4099L3.35264 13.1708L0.857439 14.1441Z" fill="#471966"/>
// <path fill="${this.themeColor || '#000'}" d="M8.07111 4.73437C8.09992 4.76321 8.13412 4.78609 8.17178 4.80169C8.20943 4.8173 8.24979 4.82534 8.29055 4.82534C8.33131 4.82534 8.37167 4.8173 8.40932 4.80169C8.44697 4.78609 8.48118 4.76321 8.50998 4.73437L11.6679 1.57647L12.3259 2.234L9.16751 5.39087C9.10943 5.44902 9.07681 5.52785 9.07681 5.61005C9.07681 5.69224 9.10943 5.77107 9.16751 5.82922C9.19632 5.85806 9.23053 5.88094 9.26818 5.89654C9.30583 5.91215 9.34619 5.92019 9.38695 5.92019C9.42771 5.92019 9.46807 5.91215 9.50572 5.89654C9.54337 5.88094 9.57758 5.85806 9.60638 5.82922L12.7643 2.67132L13.4223 3.32937L10.2655 6.48882C10.2366 6.51763 10.2138 6.55183 10.1981 6.58948C10.1825 6.62714 10.1745 6.6675 10.1745 6.70826C10.1745 6.74901 10.1825 6.78937 10.1981 6.82703C10.2138 6.86468 10.2366 6.89889 10.2655 6.92769C10.3236 6.98577 10.4025 7.0184 10.4846 7.0184C10.5668 7.0184 10.6457 6.98577 10.7038 6.92769L14.0814 3.55009L14.6655 2.96597C15.0837 2.54777 15.1137 1.89696 14.7317 1.51496L13.4839 0.268129C13.1018 -0.11388 12.45 -0.0838984 12.0328 0.333778L11.4487 0.918422L8.07111 4.29602C8.01303 4.35417 7.98041 4.433 7.98041 4.5152C7.98041 4.59739 8.01303 4.67622 8.07111 4.73437Z" fill="#471966"/>
// </svg>

//         `)
//       },
//       {
//         label: this.user.user.questions[2].questions,
//         icon: 'assets/icon/Default_theme/Default_3.svg',
//         customSvgPath: 'M3 3h10v10H3z',
//         iconSvg: this.sanitizer.bypassSecurityTrustHtml(`
//          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path fill="${this.themeColor || '#000'}" d="M14.0444 0H1.95556C0.871111 0 0 0.817778 0 1.83111V11.0222C0 12.0356 0.871111 12.8533 1.95556 12.8533H3.23556V15.5733C3.23556 15.7333 3.34222 15.8933 3.50222 15.9644C3.57333 16 3.62667 16 3.69778 16C3.80444 16 3.91111 15.9644 4 15.9111L8.03556 12.8533H14.0444C15.1289 12.8533 16 12.0356 16 11.0222V1.83111C16 0.817778 15.1289 0 14.0444 0ZM15.0933 11.0044C15.0933 11.5378 14.6311 11.9644 14.0622 11.9644H7.85778C7.75111 11.9644 7.64444 12 7.55556 12.0533L4.16 14.6311V12.3911C4.16 12.16 3.94667 11.9644 3.69778 11.9644H1.95556C1.38667 11.9644 0.924444 11.5378 0.924444 11.0044V1.86667C0.924444 1.33333 1.38667 0.906667 1.95556 0.906667H14.08C14.6489 0.906667 15.1111 1.33333 15.1111 1.86667V11.0044H15.0933Z" fill="#471966"/>
// <path fill="${this.themeColor || '#000'}" d="M4.62221 6.70267H7.14665V5.81378H4.62221V4.71155H7.35999V3.78711H3.55554V8.97822H7.48443V8.036H4.62221V6.70267Z" fill="#471966"/>
// <path fill="${this.themeColor || '#000'}" d="M11.5199 7.41378L9.45772 3.78711H8.31995V8.97822H9.33328V5.29822L11.4488 8.97822H12.5333V3.78711H11.5199V7.41378Z" fill="#471966"/>
// </svg>

//         `)
//       },
//       {
//         label: this.user.user.questions[3].questions,
//         icon: 'assets/icon/Default_theme/Default_4.svg',
//         customSvgPath: 'M5 5h6v6H5z',
//         iconSvg: this.sanitizer.bypassSecurityTrustHtml(`
//           <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path fill="${this.themeColor || '#000'}" fill-rule="evenodd" clip-rule="evenodd" d="M9.73151 0.376318C9.73151 0.376318 9.69712 0.0015686 10.1069 0.0015686C11.1398 0.0015686 11.977 0.839661 11.977 1.87459V1.876C11.977 2.91167 11.1391 3.75119 10.1055 3.75119C9.89918 3.75119 9.73147 3.58315 9.73147 3.37644V3.75119C9.73147 3.87353 9.67253 3.98813 9.57218 4.05774L8.94274 4.50069L9.57218 4.94363C9.61358 4.97176 9.64726 5.00832 9.67323 5.0484C9.7855 5.03363 9.89988 5.0259 10.015 5.0259C10.709 5.0259 11.3749 5.30293 11.8662 5.79439C12.1665 6.09462 11.8676 6.32523 11.8676 6.32523L9.74977 8.44719C9.74346 8.45351 9.73785 8.45914 9.73083 8.46476V11.5808C9.73644 11.4817 9.78486 11.2504 10.1062 11.2504C11.1392 11.2504 11.9763 12.0885 11.9763 13.1234V13.1248C11.9763 14.1605 11.1384 15 10.1048 15C9.8985 15 9.73079 14.832 9.73079 14.6253H2.24554C2.24554 14.832 2.07783 15 1.87153 15C0.837896 15 3.59768e-05 14.1605 3.59768e-05 13.1248V13.1234C3.59768e-05 12.0884 0.837196 11.2504 1.87009 11.2504C2.19219 11.2504 2.2399 11.4824 2.2455 11.5808V9.74993C2.2455 9.65009 2.2855 9.55517 2.35497 9.48415L2.83916 8.99971L2.35497 8.51527C2.2855 8.44496 2.2455 8.34934 2.2455 8.24949V3.37487C2.2455 3.58158 2.07779 3.74962 1.87149 3.74962C0.83786 3.74962 0 2.9101 0 1.87443V1.87303C0 0.838056 0.83716 0 1.87006 0C2.28057 0 2.24547 0.374749 2.24547 0.374749H9.73072L9.73151 0.376318ZM1.49823 12.0648V14.1875C1.06176 14.0328 0.749491 13.6159 0.749491 13.1265V13.1251C0.749491 12.6357 1.06246 12.2195 1.49823 12.0655V12.0648ZM10.4802 12.0648V14.1875C10.9167 14.0328 11.229 13.6159 11.229 13.1265V13.1251C11.229 12.6357 10.916 12.2195 10.4802 12.0655V12.0648ZM2.24697 12.3763V13.876H9.73222V12.3763H2.24697ZM8.98348 3.37656H2.99571V8.09585L3.63498 8.73567C3.78094 8.88262 3.78094 9.11957 3.63498 9.26651L2.99571 9.90634V11.6261H8.98348V8.55777H8.80174V9.2433C8.80174 9.34314 8.76315 9.43805 8.69227 9.50908C8.69227 9.50908 8.2951 9.90703 7.89722 10.3057C7.61653 10.5869 7.2362 10.7444 6.83973 10.7444C6.57027 10.7444 6.30783 10.672 6.07906 10.5363L5.25173 11.366C5.10577 11.5122 4.86859 11.5122 4.72263 11.366C4.57597 11.2197 4.57597 10.9821 4.72263 10.8359L5.54997 10.0062C5.41524 9.77768 5.34297 9.51471 5.34297 9.24401C5.34297 8.84677 5.50086 8.46498 5.78154 8.18374C6.42924 7.53477 7.36392 6.59753 8.16393 5.79665C8.3548 5.6047 8.57233 5.4465 8.8074 5.32346L8.07621 4.80878C7.97657 4.73917 7.91692 4.62457 7.91692 4.50223C7.91692 4.37989 7.97657 4.26529 8.07621 4.19568L8.98354 3.55726L8.98348 3.37656ZM6.31062 9.77412C6.16957 9.6342 6.09097 9.44296 6.09097 9.24398C6.09097 9.045 6.16956 8.85445 6.31062 8.71384L8.69301 6.32675C9.04386 5.9752 9.51964 5.77762 10.0158 5.77762C10.3856 5.77762 10.7441 5.88731 11.0473 6.0891L9.33087 7.8089H8.42777C8.22147 7.8089 8.05376 7.97694 8.05376 8.18365V9.08854L7.36888 9.77547C7.22924 9.91539 7.03908 9.99413 6.84048 9.99413C6.64189 9.99413 6.45242 9.91538 6.31209 9.77547L6.31139 9.77406L6.31062 9.77412ZM1.49823 0.815775V2.93845C1.06176 2.78377 0.749491 2.36683 0.749491 1.87747V1.87607C0.749491 1.3867 1.06246 0.970479 1.49823 0.816493V0.815775ZM10.4802 0.815775V2.93845C10.9167 2.78377 11.229 2.36683 11.229 1.87747V1.87607C11.229 1.3867 10.916 0.970479 10.4802 0.816493V0.815775ZM9.73151 2.62688V1.12717H2.24625V2.62688H9.73151Z" fill="#471966"/>
// </svg>

//         `)
//       }
//     ];
//   }

//   updateIconsByTheme() {

//     if (
//       this.themeApplied === 'camp_wings' ||
//       this.themeApplied === 'spin_and_swing' ||
//       this.themeApplied === 'cricket_fever' ||
//       this.themeApplied === 'learning_lane' ||
//       this.themeApplied === 'jump_shot'
//     ) {
//       this.suggestionChips = [
//         {
//           icon: 'assets/icon/Other_theme/Suggestion_quetion_1.svg',
//           // label: "Explain Newton's Laws in simple terms.",
//           customSvgPath: ""
//         },
//         {
//           icon: 'assets/icon/Other_theme/Suggestion_quetion_2.svg',
//           // label: "Solve a quadratic equation: x² + 5x + 6 = 0",
//           customSvgPath: ""
//         },
//         {
//           icon: 'assets/icon/Other_theme/Suggestion_quetion_3.svg',
//           // label: "Help me with my English essay.",
//           customSvgPath: ""
//         },
//         {
//           icon: 'assets/icon/Other_theme/Suggestion_quetion_4.svg',
//           // label: "What are the key features of the Constitution?",
//           customSvgPath: ""
//         }
//       ];
//     } else if (this.themeApplied === 'nebula_way') {
//       this.suggestionChips = [
//         {
//           icon: 'assets/icon/Dark_theme/Suggestion_quetion_1.svg',
//           // label: "Explain Newton's Laws in simple terms.",
//           customSvgPath: ""
//         },
//         {
//           icon: 'assets/icon/Dark_theme/Suggestion_quetion_2.svg',
//           // label: "Solve a quadratic equation: x² + 5x + 6 = 0",
//           customSvgPath: ""
//         },
//         {
//           icon: 'assets/icon/Dark_theme/Suggestion_quetion_3.svg',
//           // label: "Help me with my English essay.",
//           customSvgPath: ""
//         },
//         {
//           icon: 'assets/icon/Dark_theme/Suggestion_quetion_4.svg',
//           // label: "What are the key features of the Constitution?",
//           customSvgPath: ""
//         }
//       ];
//     } else {
//       this.suggestionChips = [
//         {
//           icon: 'assets/icon/Default_theme/Default_1.svg',
//           // label: "Explain Newton's Laws in simple terms.",
//           customSvgPath: ""
//         },
//         {
//           icon: 'assets/icon/Default_theme/Default_2.svg',
//           // label: "Solve a quadratic equation: x² + 5x + 6 = 0",
//           customSvgPath: ""
//         },
//         {
//           icon: 'assets/icon/Default_theme/Default_3.svg',
//           // label: "Help me with my English essay.",
//           customSvgPath: ""
//         },
//         {
//           icon: 'assets/icon/Default_theme/Default_4.svg',
//           // label: "What are the key features of the Constitution?",
//           customSvgPath: ""
//         }
//       ];

//     }
//   }
//   setGreeting(): void {
//     const hour = new Date().getHours();

//     if (hour < 12) {
//       this.greetingMessage = 'Good Morning ';
//       if (this.themeApplied === 'nebula_way') {
//         this.greetingIcon = 'assets/icon/Dark_theme/greetingsIconDarkthemeMorning.svg';
//       } else {
//         this.greetingIcon = 'assets/icon/Default_theme/GreetingsiconMorninglighttheme.svg';
//       }
//     } else if (hour < 18) {
//       this.greetingMessage = 'Good Afternoon ';
//       if (this.themeApplied === 'nebula_way') {
//         this.greetingIcon = 'assets/icon/Dark_theme/greetingsIconDarkthemeMorning.svg';
//       } else {
//         this.greetingIcon = 'assets/icon/Default_theme/GreetingsiconMorninglighttheme.svg';
//       }
//     } else {
//       this.greetingMessage = 'Good Evening ';
//       if (this.themeApplied === 'nebula_way') {
//         this.greetingIcon = 'assets/icon/Dark_theme/greetingsIconDarkthemeMorning.svg';
//       } else {
//         this.greetingIcon = 'assets/icon/Default_theme/GreetingsiconMorninglighttheme.svg';
//       }
//     }
//   }

//   get isDarkMode(): boolean {
//     return this.themeService.getCurrentTheme()
//   }

//   convertChatsToMessages(chats: Chat[]): ChatMessage[] {
//     return chats.flatMap((chat) => [
//       {
//         content: chat.query,
//         Text: chat.query,
//         sender: "user",
//         timestamp: new Date(chat.timestamp),
//         sessionId: chat.sessionId || "", // ✅ Ensure sessionId is included
//         audioUrl: undefined, // ✅ Explicitly set audioUrl for user messages
//       },
//       {
//         content: chat.response,
//         Text: chat.response,
//         sender: "ai",
//         timestamp: new Date(chat.timestamp),
//         sessionId: chat.sessionId || "", // ✅ Ensure sessionId is included
//         audioUrl: chat.audio_url || undefined, // ✅ Handle audioUrl properly
//       },
//     ]);
//   }

//   loadChatMessages(sessionId: string): void {
//     var pageNumber = 1
//     this.chatService.getChatHistory(pageNumber, this.user.user.id, sessionId).subscribe(
//       (history: any) => {
//         console.log(history, 'history')
//         this._selectedChat = history.data[0];
//         this.messages = this.convertChatsToMessages(history.data[0].chats || []);
//         this.groupedMessages = this.groupMessagesByDateHistory(this.messages);
//         console.log(this.groupedMessages, 'grouped message')
//         // this.messages = this.convertChatsToMessages(chatSession.chats || []);
//       },
//       (error) => {
//         // console.error("Failed to load chat messages:", error);
//         // this.messages = [{
//         //   content: "Unable to load messages.",
//         //   sender: "system",
//         //   timestamp: new Date(),
//         //   sessionId,
//         // }];
//       }
//     );
//   }

//   sendMessage(): void {



//     if (!this.isMoved) {
//       this.isMoved = true;
//     }


//     if (this.chatForm.valid && !this.isTyping) {
//       this.stopAudio();
//       const userMessage = this.chatForm.get("message")?.value;
//       const currentTime = new Date();
//       // this.shouldScroll = true;


//       const userId = this.user.user.id;

//       // Use the stored session ID if available, otherwise check _selectedChat
//       const sessionId = this.sessionId;

//       // Send empty string for a new chat

//       // Add user message to chat
//       this.messages.push({
//         content: userMessage,
//         Text: userMessage,
//         sender: "user",
//         timestamp: currentTime,
//         sessionId: this.sessionId || "", // ✅ Ensure sessionId is included
//         // type: "text", // ✅ Add a type field for future scalability

//       });


//       this.chatForm.reset();
//       this.isTyping = true;
//       this.shouldScroll = true;
//       console.log(this.user.user.studentClass.grade, 'chat component')
//       const collectionName = this.classToCollectionMap[this.user.user.studentClass.grade];
//       // Prepare request payload
//       const requestData = {
//         userId: userId,
//         sessionId: sessionId, // Empty if new chat
//         query: userMessage,
//         collection_name: collectionName,
//         api_auth_key: '123456789',
//         // no_of_source:'2',
//         search_type: 'similarity',
//         "school": this.user.user.schoolId
//         // history:''

//       };


//       // Simulate AI typing
//       setTimeout(() => {
//         this.chatService.sendMessage(requestData).subscribe(
//           (response: any) => {
//             this.isTyping = false;
//             this.fullMessage = response.content as string;
//             this.displayedMessage = "";
//             this.wordIndex = 0;
//             this.stopRevealing();
//             this.revealWords();

//             if (!this.sessionId && response.sessionId) {
//               this.sessionId = response.sessionId;
//             }

//             this.chatService.notifyChatUpdated();
//             this.messages.push({
//               ...response,
//               content: "",
//             });
//             setTimeout(() => {
//               this.chatService.triggerRefresh();
//             }, 3000);
//             this.shouldScroll = true; // ✅ FIX: trigger scroll after message is pushed
//             // this.scrollToBottom();
//           },
//           (error) => {
//             console.error("Error:", error);
//             this.isTyping = false;
//             this.messages.push({
//               content: "Sorry, there was an error processing your request.",
//               Text: "Sorry, there was an error processing your request.",
//               sender: "ai",
//               timestamp: new Date(),
//               sessionId: this.sessionId || "",
//             });

//             this.shouldScroll = true; // ✅ also scroll in error case
//           }
//         );

//       }, 1000);
//     }
//   }

//   // sendMessage(): void {
//   //   if (this.chatForm.valid && !this.isTyping) {
//   //     const userMessage = this.chatForm.get("message")?.value
//   //     const currentTime = new Date()
//   //     this.shouldScroll = true;
//   //     // Add user message
//   //     this.messages.push({
//   //       content: userMessage,
//   //       Text:userMessage,
//   //       sender: "user",
//   //       timestamp: currentTime,
//   //     })

//   //     this.chatForm.reset()
//   //     this.isTyping = true

//   //     // Simulate AI typing
//   //     setTimeout(() => {
//   //       this.chatService.sendMessage(userMessage).subscribe(
//   //         (response) => {
//   //           this.isTyping = false
//   //           this.fullMessage = response.content as string
//   //           this.displayedMessage = ""
//   //           this.wordIndex = 0
//   //           this.revealWords()
//   //           this.messages.push({
//   //             ...response,
//   //             content: "",
//   //           })
//   //         },
//   //         (error) => {
//   //           console.error("Error:", error)
//   //           this.isTyping = false
//   //           this.messages.push({
//   //             content: "Sorry, there was an error processing your request.",
//   //             sender: "ai",
//   //             Text:"Sorry, there was an error processing your request.",
//   //             timestamp: new Date(),
//   //           })
//   //         },
//   //       )
//   //     }, 1000)
//   //   }
//   // }

//   revealWords(): void {
//     this.isRevealing = true;

//     this.revealInterval = setInterval(() => {
//       const words = this.fullMessage.split(" ");

//       if (this.wordIndex < words.length) {
//         this.displayedMessage += (this.wordIndex > 0 ? " " : "") + words[this.wordIndex];
//         this.wordIndex++;
//         this.updateLastMessage();

//         // ✅ Only scroll if user is at the bottom (i.e., has not scrolled up)
//         this.scrollToBottom(this.autoScrollEnabled); // It internally checks `shouldScroll`
//       } else {
//         clearInterval(this.revealInterval);
//         this.isRevealing = false;
//       }
//     }, 100);
//   }

//   private isUserScrolling = false;

//   lastScrollTop = 0;
//   onScroll(): void {
//     if (this.isProgrammaticScroll) {
//       console.log('🚫 Ignored programmatic scroll');
//       return;
//     }

//     const el = this.chatContent.nativeElement;
//     const threshold = 20;
//     const isAtBottom = el.scrollHeight - el.scrollTop - el.clientHeight < threshold;

//     if (this.autoScrollEnabled && !isAtBottom) {
//       console.log('🛑 User scrolled up — disabling auto-scroll');
//       this.autoScrollEnabled = false;
//     } else if (!this.autoScrollEnabled && isAtBottom) {
//       console.log('✅ User reached bottom — enabling auto-scroll');
//       this.autoScrollEnabled = true;
//     }
//   }





//   stopRevealing(): void {
//     clearInterval(this.revealInterval);
//     this.isRevealing = false; // Stop revealing words
//   }
//   updateLastMessage(): void {
//     if (this.messages.length > 0) {
//       this.messages[this.messages.length - 1].content = this.displayedMessage
//     }
//   }

//   formatAndUpdateLastMessage(): void {
//     if (this.messages.length > 0) {
//       const formattedContent = this.formatMessage(this.fullMessage)
//       this.messages[this.messages.length - 1].content = formattedContent
//     }
//   }
//   // ngAfterViewChecked(): void {
//   //   if (typeof MathJax !== 'undefined') {
//   //     MathJax.typesetPromise(); // Render math
//   //   }
//   // }
//   // formatMessage(content: string): SafeHtml {
//   //   // Step 1: Normalize line endings and trim input
//   //   let formatted = content.trim().replace(/\r\n/g, "\n");

//   //   // Step 2: Handle bold (**bold**)
//   //   formatted = formatted.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

//   //   // Step 3: Handle inline code (`code`)
//   //   formatted = formatted.replace(/`(.*?)`/g, "<code>$1</code>");

//   //   // Step 4: Format numbered lists (1. Item)
//   //   formatted = formatted.replace(/(?:^|\n)(\d+\.\s.+)/g, "\n<li>$1</li>");
//   //   formatted = formatted.replace(/(<li>\d+\..+<\/li>\s*)+/g, match => `<ol>${match.trim()}</ol>`);

//   //   // Step 5: Format unordered lists (- item or * item)
//   //   formatted = formatted.replace(/(?:^|\n)[\-\*]\s(.+)/g, "\n<li>$1</li>");
//   //   formatted = formatted.replace(/(<li>.+<\/li>\s*)+/g, match => {
//   //     return match.includes("<ol>") ? match : `<ul>${match.trim()}</ul>`;
//   //   });

//   //   // // Step 6: Format LaTeX block equations (surrounded by $$...$$ or \[...\])
//   //   // formatted = formatted.replace(/\$\$(.*?)\$\$/gs, (_, eq) => `<div>\\[${eq.trim()}\\]</div>`);
//   //   // formatted = formatted.replace(/\\\[(.*?)\\\]/gs, (_, eq) => `<div>\\[${eq.trim()}\\]</div>`);

//   //   // // Step 7: Format inline LaTeX math (surrounded by \( ... \) or $...$)
//   //   // formatted = formatted.replace(/(?<!\\)\$(.+?)(?<!\\)\$/g, (_, eq) => `<span>\\(${eq.trim()}\\)</span>`);
//   //   // formatted = formatted.replace(/\\\((.*?)\\\)/g, (_, eq) => `<span>\\(${eq.trim()}\\)</span>`);

//   //   // Step 8: Replace paragraph breaks and line breaks
//   //   formatted = formatted.replace(/\n{2,}/g, "<br><br>");
//   //   formatted = formatted.replace(/\n/g, "<br>");

//   //   // Step 9: Clean <br> between list tags
//   //   formatted = formatted.replace(/<br>(?=<\/?li>)/g, "");

//   //   return this.sanitizer.bypassSecurityTrustHtml(formatted);
//   // }
//   fixLatex(latex: string): string {
//     let fixed = latex;

//     // Fix duplicate subscripts: I_1_1 → I_1
//     fixed = fixed.replace(/([A-Za-z])_(\d+)_\d+/g, '$1_$2');

//     // Remove nested \frac{\frac{...}} → \frac{...}
//     while (/\\frac{\\frac{([^{}]+)}}/.test(fixed)) {
//       fixed = fixed.replace(/\\frac{\\frac{([^{}]+)}}/g, '\\frac{$1}');
//     }

//     // Balance braces
//     const openBraces = (fixed.match(/{/g) || []).length;
//     const closeBraces = (fixed.match(/}/g) || []).length;
//     if (openBraces > closeBraces) {
//       fixed += '}'.repeat(openBraces - closeBraces);
//     }
//     if (closeBraces > openBraces) {
//       fixed = fixed.replace(/}+$/g, '');
//     }

//     return fixed.trim();
//   }

//   // formatMessage(content: string): SafeHtml {
//   //   console.log("🚀 ~ ChatComponent ~ formatMessage ~ content:", content)
//   //   let formatted = content.trim();

//   //   // --- Escape HTML ---
//   //   formatted = formatted
//   //     .replace(/&/g, "&amp;")
//   //     .replace(/</g, "&lt;")
//   //     .replace(/>/g, "&gt;");

//   //   // --- Preserve code blocks ---
//   //   const preBlocks: string[] = [];
//   //   formatted = formatted.replace(/```([\s\S]*?)```/g, (_, code) => {
//   //     preBlocks.push(`<pre><code>${code.trim()}</code></pre>`);
//   //     return `@@CODEBLOCK${preBlocks.length - 1}@@`;
//   //   });

//   //   // --- Bold headings (## Heading or Step X:) ---
//   //   formatted = formatted.replace(/^##\s*(.+)$/gm, (_, text) => `<strong>${text.trim()}</strong>`);
//   //   formatted = formatted.replace(/Step (\d+):/g, (_, stepNum) => `<br/><strong>Step ${stepNum}:</strong><br/>`);

//   //   // --- Wrap numbered steps’ content in paragraphs ---
//   //   formatted = formatted.replace(/(<strong>Step \d+:<\/strong><br\/>)([^<]+)/g, (_, heading, text) => {
//   //     return `${heading}<p>${text.trim()}</p>`;
//   //   });

//   //   // --- Bold text: **text** → <strong>text</strong> ---
//   //   formatted = formatted.replace(/\*\*(.+?)\*\*/g, (_, text) => `<strong>${text}</strong>`);

//   //   // --- Numbered lists ---
//   //   // formatted = formatted.replace(/^\d+\.\s+(.+)$/gm, (_, text) => `<li>${text}</li>`);
//   //   // formatted = formatted.replace(/(<li>[\s\S]+?<\/li>)/g, `<ol>$1</ol>`);

//   //   // --- Paragraphs for other text ---
//   //   formatted = formatted
//   //     .split(/\n{2,}/)
//   //     .map(line => {
//   //       const trimmed = line.trim();
//   //       if (!trimmed) return "";
//   //       if (
//   //         trimmed.startsWith("<strong>") ||
//   //         trimmed.startsWith("<ol>") ||
//   //         trimmed.startsWith("<pre>") ||
//   //         trimmed.startsWith('<div class="step"')
//   //       )
//   //         return trimmed;
//   //       return `<p>${trimmed}</p>`;
//   //     })
//   //     .join("");

//   //   // --- Restore code blocks ---
//   //   formatted = formatted.replace(/@@CODEBLOCK(\d+)@@/g, (_, i) => preBlocks[+i]);

//   //   // --- MathJax block: $$...$$ ---
//   //   formatted = formatted.replace(/\$\$(.+?)\$\$/gs, (_, mathContent) => {
//   //     const cleaned = this.fixLatex(mathContent); // ✅ clean before rendering
//   //     return `<div class="mathjax-block">\\[${cleaned}\\]</div>`;
//   //   });

//   //   // --- MathJax inline: $...$ ---
//   //   formatted = formatted.replace(/\$(.+?)\$/g, (_, mathContent) => {
//   //     const cleaned = this.fixLatex(mathContent); // ✅ clean before rendering
//   //     return `<span class="mathjax-inline">\\(${cleaned}\\)</span>`;
//   //   });

//   //   // --- Trigger MathJax render ---
//   //   if ((window as any).MathJax) {
//   //     (window as any).MathJax.typesetPromise();
//   //   }

//   //   return this.sanitizer.bypassSecurityTrustHtml(formatted);
//   // }

//   formatMessage(content: string): SafeHtml {
//     let formatted = content.trim();

//     // --- Escape HTML ---
//     formatted = formatted
//       .replace(/&/g, "&amp;")
//       .replace(/</g, "&lt;")
//       .replace(/>/g, "&gt;");

//     // --- Preserve code blocks ---
//     const preBlocks: string[] = [];
//     formatted = formatted.replace(/```([\s\S]*?)```/g, (_, code) => {
//       preBlocks.push(`<pre><code>${code.trim()}</code></pre>`);
//       return `@@CODEBLOCK${preBlocks.length - 1}@@`;
//     });

//     // --- Bold headings (## Heading or Step X:) ---
//     formatted = formatted.replace(/^##\s*(.+)$/gm, (_, text) => `<strong>${text.trim()}</strong>`);
//     formatted = formatted.replace(/Step (\d+):/g, (_, stepNum) =>
//       `<br/><strong>Step ${stepNum}:</strong><br/>`
//     );

//     // --- Wrap numbered steps’ content in paragraphs ---
//     formatted = formatted.replace(
//       /(<strong>Step \d+:<\/strong><br\/>)([^<]+)/g,
//       (_, heading, text) => `${heading}<p>${text.trim()}</p>`
//     );

//     // --- Bold text: **text** ---
//     formatted = formatted.replace(/\*\*(.+?)\*\*/g, (_, text) => `<strong>${text}</strong>`);

//     // --- Numbered lists (CORRECT) ---
//     formatted = formatted.replace(
//       /(?:^\d+\.\s+.+$(?:\n\s*)?)+/gm,
//       (match) => {
//         const items = match
//           .trim()
//           .split(/\n+/)
//           .filter(line => /^\d+\.\s+/.test(line))
//           .map(line => line.replace(/^\d+\.\s+/, "").trim())
//           .map(text => `<li>${text}</li>`)
//           .join("");
//         return `<ol>${items}</ol>`;
//       }
//     );

//     // --- Preserve ordered lists (IMPORTANT) ---
//     const olBlocks: string[] = [];
//     formatted = formatted.replace(/<ol>[\s\S]*?<\/ol>/g, (match) => {
//       olBlocks.push(match);
//       return `@@OLBLOCK${olBlocks.length - 1}@@`;
//     });

//     // --- Paragraph wrapping ---
//     formatted = formatted
//       .split(/\n{2,}/)
//       .map(line => {
//         const trimmed = line.trim();
//         if (!trimmed) return "";
//         if (
//           trimmed.startsWith("<strong>") ||
//           trimmed.startsWith("<pre>") ||
//           trimmed.startsWith("@@OLBLOCK") ||
//           trimmed.startsWith('<div class="step"')
//         ) {
//           return trimmed;
//         }
//         return `<p>${trimmed}</p>`;
//       })
//       .join("");

//     // --- Restore ordered lists ---
//     formatted = formatted.replace(/@@OLBLOCK(\d+)@@/g, (_, i) => olBlocks[+i]);

//     // --- Restore code blocks ---
//     formatted = formatted.replace(/@@CODEBLOCK(\d+)@@/g, (_, i) => preBlocks[+i]);

//     // --- MathJax block ---
//     formatted = formatted.replace(/\$\$(.+?)\$\$/gs, (_, mathContent) => {
//       const cleaned = this.fixLatex(mathContent);
//       return `<div class="mathjax-block">\\[${cleaned}\\]</div>`;
//     });

//     // --- MathJax inline ---
//     formatted = formatted.replace(/\$(.+?)\$/g, (_, mathContent) => {
//       const cleaned = this.fixLatex(mathContent);
//       return `<span class="mathjax-inline">\\(${cleaned}\\)</span>`;
//     });

//     // --- Trigger MathJax render ---
//     if ((window as any).MathJax) {
//       (window as any).MathJax.typesetPromise();
//     }

//     return this.sanitizer.bypassSecurityTrustHtml(formatted);
//   }

//   onEnter(event: Event) {
//     const keyboardEvent = event as KeyboardEvent;
//     keyboardEvent.preventDefault();

//     if (!this.isRevealing) {
//       this.sendMessage();
//     } else {
//       console.log('Bot is still responding. Stop first to send a new message.');
//     }
//   }




//   // --- Helper: check for balanced braces ---
//   hasBalancedBraces(latex: string): boolean {
//     let count = 0;
//     for (const char of latex) {
//       if (char === '{') count++;
//       if (char === '}') count--;
//       if (count < 0) return false; // extra closing brace
//     }
//     return count === 0;
//   }


//   // --- Helper: Check unbalanced braces ---
//   hasUnbalancedBraces(latex: string): boolean {
//     let stack = 0;
//     for (const char of latex) {
//       if (char === '{') stack++;
//       else if (char === '}') stack--;
//       if (stack < 0) return true; // extra closing brace
//     }
//     return stack !== 0; // true if braces are unbalanced
//   }

//   // --- Helper: Fix common LaTeX issues ---










//   // playAudio(audioUrl: string): void {
//   //   if (!audioUrl) {
//   //     console.error("Error: Audio URL is empty or undefined.");
//   //     return;
//   //   }

//   //   if (this.currentAudio) {
//   //     // If audio is already loaded, just play it
//   //     this.currentAudio.play().catch((error) => {
//   //       console.error("Error playing audio:", error);
//   //       this.audioError = true;
//   //     });
//   //   } else {
//   //     // If no audio is loaded, create a new Audio object
//   //     console.log("Playing audio from:", audioUrl);
//   //     this.currentAudio = new Audio(audioUrl);
//   //     this.currentAudio.load();

//   //     this.currentAudio.play()
//   //       .then(() => {
//   //         this.isPlayingAudio = true;
//   //         this.audioError = false;
//   //         console.log("Audio is playing", this.isPlayingAudio); // Should log true when playing
//   //       })
//   //       .catch((error) => {
//   //         console.error("Error playing audio:", error);
//   //         this.audioError = true;
//   //         this.isPlayingAudio = false;
//   //       });
//   //   }
//   // }

//   // stopAudio(): void {
//   //   if (this.currentAudio) {
//   //     console.log("Stopping audio");
//   //     this.currentAudio.pause();
//   //     this.currentAudio.currentTime = 0; // Reset audio to the beginning
//   //     this.currentAudio = null; // Release the audio resource
//   //     this.isPlayingAudio = false;
//   //   } else {
//   //     console.error("No audio to stop");
//   //   }
//   // }

//   // toggleAudio(text: any, event: Event): void {
//   //   event.stopPropagation();
//   //   var tempAudio=this.formatMessage(text)
//   //   this.shouldScroll = false;
//   //   if (this.playingMessageText === text) {
//   //     // If the same message is playing, stop it
//   //     this.stopAudio();
//   //   } else {
//   //     // Play new audio
//   //     this.playAudio(tempAudio);
//   //   }
//   // }
//   // toggleAudio(text: any, event: Event): void {
//   //   event.stopPropagation();

//   //   // Convert SafeHtml to a string


//   //   this.shouldScroll = false;

//   //   if (this.playingMessageText === text) {
//   //     // If the same message is playing, stop it
//   //     this.stopAudio();
//   //   } else {
//   //     // Play new audio
//   //     if (text) {
//   //       // this.playingMessageText = text; // Set the playing message
//   //       this.playAudio(text);
//   //     }
//   //   }
//   // }
//   toggleAudio(url: string, event: Event): void {
//     event.stopPropagation();
//     this.shouldScroll = false;

//     if (this.playingMessageUrl === url) {
//       // If the same audio is playing, stop it
//       this.stopAudio();
//     } else {
//       // Stop previous if any
//       this.stopAudio();

//       if (url) {

//         this.playAudio(url);
//         this.playingMessageUrl = url;
//       }
//     }
//   }
//   playAudio(url: string): void {
//     this.audio = new Audio(url);
//     this.audio.play();
//     this.audio.onended = () => {
//       this.playingMessageUrl = null;
//     };
//   }

//   stopAudio(): void {
//     if (this.audio) {
//       this.audio.pause();
//       this.audio.currentTime = 0;
//     }
//     this.playingMessageUrl = null;
//   }
//   getTimeString(date: Date): string {
//     return date.toLocaleTimeString("en-US", {
//       hour: "numeric",
//       minute: "2-digit",
//       hour12: true,
//     })
//   }

//   useChip(suggestion: string): void {
//     this.chatForm.patchValue({ message: suggestion })
//   }

//   toggleFullscreen(): void {
//     console.log("Toggle fullscreen")
//   }

//   toggleUserMenu(): void {
//     console.log("Toggle user menu")
//   }

//   toggleTheme(): void {
//     this.themeService.toggleTheme()
//   }

//   // private applyTheme(isDark: boolean): void {
//   //   const savedTheme = localStorage.getItem('theme') || 'light'; // Default to light
//   //   document.body.classList.toggle('dark', savedTheme === 'dark');
//   //   if (isDark) {
//   //     this.renderer.addClass(this.el.nativeElement, "dark-theme")
//   //     this.renderer.removeClass(this.el.nativeElement, "light-theme")
//   //   } else {
//   //     this.renderer.addClass(this.el.nativeElement, "light-theme")
//   //     this.renderer.removeClass(this.el.nativeElement, "dark-theme")
//   //   }
//   // }
//   private applyTheme(): void {
//     this.themeApplied = this.user.user.theme.name;
//     this.themeColor = this.user.user.theme.customTheme.accentColor;
//     this.primaryColor = this.user.user.theme.customTheme.primaryColor;

//     const allThemes = ['light-theme', 'dark-theme', 'space-theme', 'cricket-theme', 'sunset-theme'];

//     // Remove all existing theme classes from body
//     allThemes.forEach(theme => this.renderer.removeClass(document.body, theme));

//     switch (this.themeApplied) {

//       case 'nebula_way':
//         this.renderer.addClass(document.body, 'dark-theme');
//         this.isLightTheme = false;
//         break;
//       case 'spin_and_swing':
//         this.renderer.addClass(document.body, 'light-theme');
//         this.renderer.addClass(document.body, 'cricket-theme');
//         this.isLightTheme = true;
//         break;
//       case ' learning_lane':
//         this.renderer.addClass(document.body, '');
//         this.renderer.addClass(document.body, 'light-theme');
//         this.isLightTheme = false;
//         break;
//       case 'cricket_fever':
//         this.renderer.addClass(document.body, 'cricket-theme');
//         this.isLightTheme = true;
//         break;
//       case 'camp_wings':
//         this.renderer.addClass(document.body, 'camp_wings');
//         this.renderer.addClass(document.body, 'light-theme');
//         this.isLightTheme = false;
//         break;
//       case 'jump_shot':
//         this.renderer.addClass(document.body, 'jump_shot');
//         this.renderer.addClass(document.body, 'light-theme');
//         this.isLightTheme = true;
//         break;
//       default:
//         this.renderer.addClass(document.body, 'light-theme');
//         this.isLightTheme = true;
//     }
//     this.setGreeting();
//     document.documentElement.style.setProperty('--primary-color', this.themeColor);
//   }
//   initSpeechRecognition(): void {
//     if ("webkitSpeechRecognition" in window) {
//       this.recognition = new window.webkitSpeechRecognition()
//       this.recognition.continuous = false
//       this.recognition.interimResults = false

//       this.recognition.onresult = (event: any) => {
//         const transcript = event.results[0][0].transcript
//         this.ngZone.run(() => {
//           this.chatForm.patchValue({ message: transcript })
//         })
//       }

//       this.recognition.onerror = (event: any) => {
//         console.error("Speech recognition error", event.error)
//         this.ngZone.run(() => {
//           this.isListening = false
//         })
//       }

//       this.recognition.onend = () => {
//         this.ngZone.run(() => {
//           this.isListening = false
//         })
//       }
//     } else {
//       console.warn("Speech recognition not supported in this browser")
//     }
//   }

//   toggleSpeechRecognition(): void {
//     if (this.isListening) {
//       this.recognition.stop()
//     } else {
//       this.recognition.start()
//     }
//     this.isListening = !this.isListening
//   }

//   scrollToBottom(force: boolean = false): void {
//     if (!this.chatContent?.nativeElement) return;

//     const el = this.chatContent.nativeElement;
//     const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 50;

//     if (force || isAtBottom) {
//       this.isProgrammaticScroll = true;

//       setTimeout(() => {
//         el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });

//         // Delay turning off programmatic flag to let smooth scroll finish
//         setTimeout(() => {
//           this.isProgrammaticScroll = false;
//           console.log('✅ Finished programmatic scroll');
//         }, 300); // 300ms or longer if your scroll is slow
//       }, 0);
//     }
//   }








//   ngAfterViewChecked() {
//     if ((window as any).MathJax) {
//       (window as any).MathJax.typesetPromise();
//     }
//     if (this.shouldScroll && this.autoScrollEnabled) {
//       setTimeout(() => this.scrollToBottom(this.autoScrollEnabled), 0);
//       this.shouldScroll = false;
//     }
//   }



//   stripHtml(html: string): string {
//     const tempDiv = document.createElement('div');
//     tempDiv.innerHTML = html;
//     return tempDiv.textContent || tempDiv.innerText || '';
//   }
//   // playAudio(text: string): void {
//   //   var sanitizedText = this.sanitizer.sanitize(SecurityContext.HTML, this.formatMessage(text));
//   //   const plainText = this.stripHtml(sanitizedText as string);
//   //   this.chatService.getAudio(plainText).then((audioUrl: string | null) => {
//   //     if (audioUrl) {
//   //       this.stopAudio(); // Stop any previous audio
//   //       this.currentAudio = new Audio(audioUrl);
//   //       this.playingMessageText = text; // Track currently playing message

//   //       this.currentAudio.play()
//   //         .then(() => {
//   //           this.audioError = false;
//   //           console.log("Audio started playing");
//   //         })
//   //         .catch(error => {
//   //           console.error("Error playing audio:", error);
//   //           this.audioError = true;
//   //         });

//   //       this.currentAudio.onended = () => {
//   //         this.stopAudio(); // Stop audio when it finishes
//   //       };
//   //     } else {
//   //       console.error("Failed to get audio URL.");
//   //     }
//   //   });
//   // }


//   // stopAudio(): void {
//   //   if (this.currentAudio) {
//   //     this.currentAudio.pause();
//   //     this.currentAudio.currentTime = 0; // Reset
//   //     this.currentAudio = null;
//   //     this.playingMessageText = null; // Reset tracking
//   //     console.log("Audio stopped");
//   //   }
//   // }
//   toggleRevealing() {
//     if (this.isRevealing) {
//       this.stopRevealing();
//     } else {
//       this.sendMessage();
//     }
//   }

//   // stopRevealing() {
//   //   this.isRevealing = false; // Ensure state updates back to false
//   // }
//   PinChat(pinned: boolean) {
//     const selectedChat = this.selectedChat;
//     const sessionId = selectedChat?.sessionId;

//     // if (!sessionId) {
//     //   console.error('sessionId is undefined');
//     //   Swal.fire({
//     //     icon: 'error',
//     //     title: 'Missing Session ID',
//     //     text: 'Unable to identify the chat session.',
//     //   });
//     //   return;
//     // }

//     // if (typeof selectedChat.pinned !== 'boolean') {
//     //   console.error('Pinned state is invalid or missing');
//     //   Swal.fire({
//     //     icon: 'error',
//     //     title: 'Invalid Data',
//     //     text: 'Cannot determine current pinned state.',
//     //   });
//     //   return;
//     // }
//     // const sessionId = this.selectedChat.sessionId;
//     const newPinnedState = !this._selectedChat.pinned;
//     console.log('Pin status updated:', newPinnedState);
//     this.chatService.pinSession(sessionId, newPinnedState).subscribe({
//       next: (response: any) => {
//         console.log('Pin status updated:', response);

//         // selectedChat.pinned = newPinnedState; // update locally
//         if (this.sessionId) {
//           this.loadChatMessages(this.sessionId);
//         }
//         Swal.fire({
//           icon: 'success',
//           title: newPinnedState ? 'Pinned!' : 'Unpinned!',
//           text: response.message || 'Chat session updated successfully.',
//           timer: 2000,
//           showConfirmButton: false,
//         });

//         this.chatService.triggerRefresh(); // optional UI refresh
//       },
//       error: (error) => {
//         console.error('Error pinning session:', error);
//         Swal.fire({
//           icon: 'error',
//           title: 'Update Failed',
//           text: error?.error?.message || 'Something went wrong. Please try again later.',
//         });
//       }
//     });
//   }



//   iconPathsByTheme: { [theme: string]: string[] } = {
//     nebula_way: [
//       'assets/icon/nebula/Suggestion_1.svg',
//       'assets/icon/nebula/Suggestion_2.svg',
//       'assets/icon/nebula/Suggestion_3.svg',
//       'assets/icon/nebula/Suggestion_4.svg'
//     ],
//     spin_and_swing: [
//       'assets/icon/cricket/Suggestion_1.svg',
//       'assets/icon/cricket/Suggestion_2.svg',
//       'assets/icon/cricket/Suggestion_3.svg',
//       'assets/icon/cricket/Suggestion_4.svg'
//     ],
//     learning_lane: [
//       'assets/icon/light/Suggestion_1.svg',
//       'assets/icon/light/Suggestion_2.svg',
//       'assets/icon/light/Suggestion_3.svg',
//       'assets/icon/light/Suggestion_4.svg'
//     ],
//     cricket_fever: [
//       'assets/icon/cricket2/Suggestion_1.svg',
//       'assets/icon/cricket2/Suggestion_2.svg',
//       'assets/icon/cricket2/Suggestion_3.svg',
//       'assets/icon/cricket2/Suggestion_4.svg'
//     ],
//     camp_wings: [
//       'assets/icon/camp/Suggestion_1.svg',
//       'assets/icon/camp/Suggestion_2.svg',
//       'assets/icon/camp/Suggestion_3.svg',
//       'assets/icon/camp/Suggestion_4.svg'
//     ]
//   };
//   // getTimeString(timestamp: string): string {
//   //   const date = new Date(timestamp);
//   //   return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); // e.g., "04:23 PM"
//   // }
//   groupMessagesByDate(): void {
//     const groups: { [key: string]: any[] } = {};

//     this.messages.forEach((msg) => {
//       const date = new Date(msg.timestamp);
//       const label = this.getDateLabel(date);

//       if (!groups[label]) {
//         groups[label] = [];
//       }
//       groups[label].push(msg);
//     });

//     // Convert to array for *ngFor
//     this.groupedMessages = Object.keys(groups).map(label => ({
//       label,
//       messages: groups[label]
//     }));
//   }

//   // 👇 Helper to generate "Today", "Yesterday", etc.
//   getDateLabel(date: Date): string {
//     const today = new Date();
//     const yesterday = new Date(today);
//     yesterday.setDate(today.getDate() - 1);

//     if (
//       date.toDateString() === today.toDateString()
//     ) {
//       return 'Today';
//     } else if (
//       date.toDateString() === yesterday.toDateString()
//     ) {
//       return 'Yesterday';
//     } else {
//       return date.toLocaleDateString(undefined, {
//         day: 'numeric',
//         month: 'short',
//         year: 'numeric'
//       });
//     }
//   }

//   groupMessagesByDateHistory(messages: any[]): { date: string, messages: any[] }[] {
//     const grouped: { [key: string]: any[] } = {};

//     for (let msg of messages) {
//       const dateKey = this.getDateGroupLabel(new Date(msg.timestamp));
//       if (!grouped[dateKey]) {
//         grouped[dateKey] = [];
//       }
//       grouped[dateKey].push(msg);
//     }

//     return Object.keys(grouped).map(date => ({
//       date,
//       messages: grouped[date]
//     }));
//   }

//   getDateGroupLabel(date: Date): string {
//     const today = new Date();
//     const yesterday = new Date();
//     yesterday.setDate(today.getDate() - 1);

//     const isToday = date.toDateString() === today.toDateString();
//     const isYesterday = date.toDateString() === yesterday.toDateString();

//     if (isToday) return 'Today';
//     if (isYesterday) return 'Yesterday';

//     return formatDate(date, 'd MMMM y', 'en-IN'); // e.g., 4 August 2025
//   }
//   // @ViewChild('scrollContainer') scrollContainer!: ElementRef;

//   // scrollToBottom(): void {
//   //   try {
//   //     this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
//   //   } catch (err) {}
//   // }
// }



import { Component, OnInit, Renderer2, ElementRef, NgZone, Input, ViewChild, SecurityContext, AfterViewChecked, AfterViewInit } from "@angular/core"
import { FormBuilder, FormGroup, Validators } from "@angular/forms"
import { ChatMessage, ChatService, ChatSession, Chat } from "../../services/chat.service"
import { AuthService } from "../../services/auth.service"
import { ThemeService } from "../../theme.service"
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser"
import Swal from 'sweetalert2';
import { formatDate } from "@angular/common"
import { Subscription } from 'rxjs';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { environment } from '../../../environments/environment';
import { TrialSubscriptionService } from '../../admin/services/trial-subscription.service';
import { getStudentThemeVisual, isJuniorStudentTheme, normalizeStudentThemeName } from '../student-theme.util';
// import {
//   getStudentThemeVisual,
//   isJuniorStudentTheme,
//   normalizeStudentThemeName
// } from '../student-theme.util';

declare global {
  interface Window {
    MathJax: any;
  }
}
// interface ChatMessage {
//   content: string
//   sender: "user" | "ai"
//   timestamp: Date
//   status?: "sent" | "read"
// }
declare global {
  interface Window {
    webkitSpeechRecognition: any
  }
}
@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  template: `<div [innerHTML]="formattedMessage"></div>`,
  styleUrls: ['./chat.component.css'],
  animations: [
    trigger('slideUp', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class ChatComponent implements AfterViewChecked, AfterViewInit {
  readonly enableStudentThemes = environment.enableStudentThemes ?? false;
  sessionId: any
    // sessionId: string | undefined

    | undefined
  autoScrollEnabled: boolean = true
  user: any
  isMoved = false;
  isRevealing = false;
  currentTheme: string = 'default';
  themeApplied: any
  isLightTheme: boolean | undefined
  pinnedSessions: any
  greetingIcon: string | undefined
  // chatId: string | null
  // groupedMessages: { label: string, messages: any[] }[] = [];
  isProgrammaticScroll = false;
  groupedMessages: any;
  chatSession: ChatSession | null = null;
  subscription!: Subscription;
  subscriptionExpired = false;
  normalizedThemeName = 'default';
  juniorThemeActive = false;
  chatThemeClass = 'student-chat-default';
  audio = new Audio();
  playingMessageUrl: string | null = null;
  classToCollectionMap: { [key: string]: string } = {
    '1': 'irish_1st_collection',
    '2': 'irish_2nd_collection',
    '3': 'irish_3rd_collection',
    '4': 'irish_4th_collection',
    '5': 'irish_5th_collection',
    '6': 'irish_6th_collection',
    '7': 'irish_7th_collection',
    '8': 'irish_8th_collection',
    '9': 'irish_9th_collection',
    '10': 'irish_10th_collection',
    '11': 'irish_11th_collection',
    '12': 'irish_12th_collection',
    '13': 'irish_test_collection',
  };
  setTheme(theme: string) {
    this.currentTheme = theme;
  }
    showScienceDecor = false;
      isCustomTheme = false;
  // sessionId: string | undefined
  @Input() set selectedChat(chat: ChatSession | null) {
    console.log("Selected Chat:", chat); // Log the incoming chat data

    this._selectedChat = chat;

    if (chat) {
      this.messages = this.convertChatsToMessages(chat.chats || []);

      console.log("Converted Messages:", this.messages); // Log the converted messages
    } else {
      this.messages = [];
    }
  }

  get selectedChat(): ChatSession | null {
    return this._selectedChat;
  }

  @ViewChild("chatContent") private chatContent!: ElementRef
  @ViewChild("chatScrollContainer") private chatScrollContainer!: ElementRef
  @ViewChild("mathKeyboardRef") private mathKeyboardRef!: ElementRef
  @ViewChild("messageInput") private messageInput!: ElementRef<HTMLTextAreaElement>
  @ViewChild("rainbowMascotVideo") private rainbowMascotVideo?: ElementRef<HTMLVideoElement>

  playingMessageText: string | null = null;
  private shouldScroll: boolean = false;
  private _selectedChat: any;
  private rainbowMascotReplayTimeout?: ReturnType<typeof setTimeout>;
  chatForm: FormGroup
  messages: ChatMessage[] = []
  isTyping = false
  maxLength = 1000
  userName = "John"
  userImageUrl = "../../assets/user-avatar.jpg"
  currentAudio: HTMLAudioElement | null = null
  displayedMessage = ""
  fullMessage = ""
  wordIndex = 0
  revealInterval: any
  accentColor = "#e60f0f";
  primaryColor = "#c2c4c7"
  themeColor: string = '';
  isPlayingAudio = false
  audioError = false
  isSidebarOpen = false
  isListening = false
  recognition: any
  greetingMessage: string = '';
  suggestionChips: any;
  
  // Math Keyboard properties
  showMathKeyboard = false;
  activeKeyboardTab: 'operators' | 'functions' | 'trig' | 'calculus' | 'matrices' = 'operators';
  
  operatorKeys = [
    { display: '+', symbol: '+' },
    { display: '−', symbol: '-' },
    { display: '×', symbol: '×' },
    { display: '÷', symbol: '÷' },
    { display: '=', symbol: '=' },
    { display: '≠', symbol: '≠' },
    { display: '<', symbol: '<' },
    { display: '>', symbol: '>' },
    { display: '≤', symbol: '≤' },
    { display: '≥', symbol: '≥' },
    { display: '±', symbol: '±' },
    { display: '∓', symbol: '∓' },
    { display: '√', symbol: '√' },
    { display: 'x²', symbol: '²' },
    { display: 'x³', symbol: '³' },
    { display: 'xⁿ', symbol: 'ⁿ' },
    { display: '^{}', symbol: '^{}' },
    { display: '_{}', symbol: '_{}' },
    { display: '₀', symbol: '₀' },
    { display: '₁', symbol: '₁' },
    { display: '₂', symbol: '₂' },
    { display: '₃', symbol: '₃' },
    { display: '₊', symbol: '₊' },
    { display: '₋', symbol: '₋' },
    { display: 'ₙ', symbol: 'ₙ' },
    { display: 'π', symbol: 'π' }
  ];
  
  functionKeys = [
    { display: 'f(x)', symbol: 'f(x)' },
    { display: 'e', symbol: 'e' },
    { display: 'log', symbol: 'log' },
    { display: 'ln', symbol: 'ln' },
    { display: 'exp', symbol: 'exp' },
    { display: 'abs', symbol: '|x|' },
    { display: 'max', symbol: 'max' },
    { display: 'min', symbol: 'min' },
    { display: '()', symbol: '()' },
    { display: '[]', symbol: '[]' },
    { display: '{}', symbol: '{}' },
    { display: '||', symbol: '||' }
  ];
  
  trigKeys = [
    { display: 'sin', symbol: 'sin' },
    { display: 'cos', symbol: 'cos' },
    { display: 'tan', symbol: 'tan' },
    { display: 'cot', symbol: 'cot' },
    { display: 'sin⁻¹', symbol: 'sin⁻¹' },
    { display: 'cos⁻¹', symbol: 'cos⁻¹' },
    { display: 'tan⁻¹', symbol: 'tan⁻¹' },
    { display: 'cot⁻¹', symbol: 'cot⁻¹' },
    { display: 'sec', symbol: 'sec' },
    { display: 'csc', symbol: 'csc' },
    { display: 'sinh', symbol: 'sinh' },
    { display: 'cosh', symbol: 'cosh' },
    { display: 'tanh', symbol: 'tanh' }
  ];
  
  calculusKeys = [
    { display: 'lim', symbol: 'lim' },
    { display: 'dx', symbol: 'dx' },
    { display: '∫', symbol: '∫' },
    { display: '∑', symbol: '∑' },
    { display: '∞', symbol: '∞' },
    { display: '∂', symbol: '∂' },
    { display: '→', symbol: '→' },
    { display: '∏', symbol: '∏' },
    { display: '∇', symbol: '∇' }
  ];
  
  greekKeys = [
    { display: 'α', symbol: 'α' },
    { display: 'β', symbol: 'β' },
    { display: 'γ', symbol: 'γ' },
    { display: 'δ', symbol: 'δ' },
    { display: 'ε', symbol: 'ε' },
    { display: 'ζ', symbol: 'ζ' },
    { display: 'η', symbol: 'η' },
    { display: 'θ', symbol: 'θ' },
    { display: 'ι', symbol: 'ι' },
    { display: 'κ', symbol: 'κ' },
    { display: 'λ', symbol: 'λ' },
    { display: 'μ', symbol: 'μ' },
    { display: 'ν', symbol: 'ν' },
    { display: 'ξ', symbol: 'ξ' },
    { display: 'ο', symbol: 'ο' },
    { display: 'ρ', symbol: 'ρ' },
    { display: 'σ', symbol: 'σ' },
    { display: 'τ', symbol: 'τ' },
    { display: 'υ', symbol: 'υ' },
    { display: 'φ', symbol: 'φ' },
    { display: 'χ', symbol: 'χ' },
    { display: 'ψ', symbol: 'ψ' }
  ];

  // Matrices / Determinants snippets
  matrixKeys = [
    {
      display: '2x2 det',
      symbol: String.raw`\begin{vmatrix}
a & b \\
c & d
\end{vmatrix}`,
    },
    {
      display: '3x3 det',
      symbol: String.raw`\begin{vmatrix}
a & b & c \\
d & e & f \\
g & h & i
\end{vmatrix}`,
    },
    {
      display: '2x2 mat',
      symbol: String.raw`\begin{bmatrix}
a & b \\
c & d
\end{bmatrix}`,
    },
    {
      display: '3x3 mat',
      symbol: String.raw`\begin{bmatrix}
a & b & c \\
d & e & f \\
g & h & i
\end{bmatrix}`,
    },
    // Inserts LaTeX matrix row break `\\`
    { display: '\\\\', symbol: String.raw`\\` },
    { display: '&', symbol: ' & ' },
    { display: 'det(x)', symbol: String.raw`\det(x)` },
  ];


  constructor(
    private fb: FormBuilder,
    private chatService: ChatService,
    private authService: AuthService,
    private trialService: TrialSubscriptionService,
    private sanitizer: DomSanitizer,
    private themeService: ThemeService,
    private renderer: Renderer2,
    private el: ElementRef,
    private ngZone: NgZone,
    private route: ActivatedRoute,  // ✅ Inject ActivatedRoute correctly
    private router: Router
  ) {
    this.chatForm = this.fb.group({
      message: ["", [Validators.required, Validators.maxLength(this.maxLength)]],
    })
  }

  ngOnInit(): void {
    // this.chatId = this.route.snapshot.paramMap.get('id');
    this.sessionId = null;
    this.user = this.authService.getUser();
    this.isCustomTheme = this.user?.user?.theme?.name === 'custom';
    const grade = Number(this.user?.user?.studentClass?.grade);
    this.showScienceDecor = this.enableStudentThemes && !Number.isNaN(grade) && grade >= 6;
    console.log(this.user, 'user details')

    // Check trial/subscription status for students
    const schoolId = this.user?.user?.schoolId;
    if (schoolId) {
      this.trialService.getSchoolTrialStatus(schoolId).subscribe({
        next: (status) => {
          if (status.trial_expired) {
            this.subscriptionExpired = true;
            Swal.fire({
              icon: 'warning',
              title: 'Subscription Expired',
              html: `
                <p>Please connect with your school admin.</p>
                <p style="font-size: 14px; color: #666; margin-top: 12px;">Your school's subscription has expired. You can still access your chat history, but new questions are disabled until your admin renews the subscription.</p>
              `,
              confirmButtonText: 'OK',
              confirmButtonColor: '#5d3e8c'
            });
          }
        },
        error: () => {
          // Silently fail - don't block chat if API fails
        }
      });
    }

    this.sessionId = this.route.snapshot.paramMap.get('id');
    this.route.paramMap.subscribe(params => {
      this.sessionId = params.get('id');
      console.log('Chat ID:', this.sessionId);
      // this.sendMessage();
      if (this.sessionId) {
        this.loadChatMessages(this.sessionId);
      }

    });
    console.log(this.sessionId, '  this.sessionId')

    this.subscription = this.chatService.currentChat$.subscribe((chat) => {
      this.chatSession = chat;

      if (!chat) {
        this.clearChat(); // New chat requested
      }
    });

    // console.log( this.user.user,'User')
    // this.getPiinedSesion();
    this.initSpeechRecognition()
    this.applyTheme();
    this.groupMessagesByDate();

    // const savedTheme = localStorage.getItem('theme') === 'dark'; // Check if the saved theme is dark
    // this.themeService.isDarkMode$.next(savedTheme); // Update BehaviorSubject with saved theme

    // this.applyTheme(savedTheme); // Apply theme immediately

    // console.log('theme:', savedTheme); // Debugging

    // Listen for theme changes and apply them dynamically
    // this.themeService.isDarkMode$.subscribe((isDarkMode) => {
    //   this.applyTheme();
    // });
    this.updateIconsByTheme();
    this.initializeSuggestionChips();
  }
  loadChat(chat: ChatSession) {
    console.log('Loading chat:', chat);
    // Load messages logic
  }

  clearChat() {
    this.sessionId = null;
    this._selectedChat = null;
    this.messages = [];
    this.groupedMessages = {};
  }

  ngOnDestroy() {
    if (this.rainbowMascotReplayTimeout) {
      clearTimeout(this.rainbowMascotReplayTimeout);
    }
    this.subscription.unsubscribe();
  }

  onRainbowMascotEnded(): void {
    if (this.rainbowMascotReplayTimeout) {
      clearTimeout(this.rainbowMascotReplayTimeout);
    }

    this.rainbowMascotReplayTimeout = setTimeout(() => {
      const video = this.rainbowMascotVideo?.nativeElement;
      if (!video) {
        return;
      }

      video.currentTime = 0;
      void video.play();
    }, 10000);
  }
  initializeSuggestionChips(): void {
    this.suggestionChips = [
      {
        label: this.user.user.questions[0].questions,
        icon: 'assets/icon/Default_theme/Default_1.svg',
        customSvgPath: `M0.415186 11.053C0.736749...`,
        iconSvg: this.sanitizer.bypassSecurityTrustHtml(`
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path  fill="${this.themeColor || '#000'}" d="M0.415186 11.053C0.736749 11.6113 1.50217 11.8965 2.58791 11.8965C3.24116 11.8965 4.01511 11.7876 4.87252 11.5784C5.43052 13.7246 6.39518 15 7.4781 15C7.67313 15 7.86941 14.9582 8.06394 14.8746C8.09931 14.859 8.9285 14.4835 9.38058 13.4693C9.63006 13.0092 9.84514 12.4481 10.0253 11.8085C10.9405 12.0772 11.747 12.2124 12.4134 12.2124C13.3096 12.2123 13.9544 11.9708 14.277 11.4913C14.5436 11.0951 14.5532 10.5655 14.3126 9.95304C14.5777 9.74516 14.75 9.43755 14.75 9.08998C14.75 8.46419 14.2055 7.95515 13.536 7.95515C13.3501 7.95515 13.1759 7.99778 13.0183 8.06818C12.8946 7.93488 12.7622 7.79966 12.6212 7.66239C14.3593 6.18685 15.062 4.8382 14.546 3.94242C14.3933 3.67608 14.136 3.47424 13.7912 3.33274C13.7854 2.72322 13.2539 2.2287 12.6004 2.2287C12.0068 2.2287 11.5174 2.63769 11.4276 3.16928C11.0107 3.22024 10.563 3.30392 10.0906 3.41944C9.53228 1.27446 8.56521 0 7.4781 0C6.42583 0 5.50625 1.16077 4.93428 3.19143C2.79087 2.56259 1.24989 2.67226 0.689175 3.50671C0.4563 3.85471 0.417132 4.28976 0.56753 4.79964C0.373497 4.99788 0.252039 5.25933 0.252039 5.54858C0.252039 6.16285 0.786565 6.66258 1.44364 6.66258C1.52476 6.66258 1.60392 6.65469 1.68054 6.64019C1.88325 6.87399 2.10418 7.1078 2.34134 7.33884C0.603133 8.81681 -0.100051 10.1636 0.415186 11.053ZM5.30058 3.81121C5.85335 3.99618 6.42347 4.22322 7.00537 4.49172C6.67398 4.63775 6.34328 4.78992 6.01775 4.95398C5.67842 5.12552 5.3438 5.30951 5.01321 5.49819C5.07956 4.90308 5.17612 4.3391 5.30058 3.81121ZM9.7093 4.01562C9.81649 4.50664 9.90103 5.02615 9.96005 5.57126C9.69364 5.39887 9.41901 5.2263 9.12926 5.0549C8.81101 4.86758 8.49156 4.6943 8.17335 4.52837C8.6972 4.3265 9.21061 4.15585 9.7093 4.01562ZM9.66092 11.1889C9.10583 11.0034 8.53617 10.7768 7.95757 10.5101C8.29428 10.3613 8.62781 10.2073 8.95017 10.044C9.2918 9.8731 9.62409 9.69095 9.95026 9.50475C9.88399 10.0952 9.78675 10.6582 9.66092 11.1889ZM10.549 6.56617C11.0264 6.91479 11.4688 7.27382 11.8742 7.63867C11.4709 7.95723 11.0249 8.27357 10.5386 8.5841C10.5598 8.22439 10.5744 7.86185 10.5744 7.49767C10.5744 7.17708 10.5641 6.86817 10.549 6.56617ZM8.85701 5.45813C9.26863 5.70159 9.65583 5.94771 10.0156 6.19092C10.0467 6.60454 10.0643 7.04168 10.0643 7.49767C10.0643 7.97284 10.0435 8.44703 10.0065 8.91181C9.58998 9.16039 9.15553 9.40046 8.70831 9.62428C8.27985 9.84128 7.83399 10.045 7.38303 10.2343C6.9459 10.0167 6.51703 9.78664 6.10891 9.54629C5.70783 9.31067 5.31944 9.0626 4.9481 8.8094C4.91702 8.39292 4.89938 7.95411 4.89938 7.49767C4.89938 7.02486 4.92014 6.5531 4.95715 6.09058C5.38135 5.83872 5.81817 5.5969 6.2601 5.37362C6.69436 5.15469 7.13781 4.95277 7.58071 4.76786C8.00334 4.97767 8.43188 5.20785 8.85701 5.45813ZM4.41487 8.43392C3.93276 8.08227 3.49047 7.7235 3.08961 7.36178C3.49959 7.03901 3.94551 6.72286 4.42503 6.41727C4.40388 6.77495 4.38926 7.13546 4.38926 7.49767C4.38926 7.81927 4.39968 8.12988 4.41487 8.43392ZM5.83716 9.94987C6.14482 10.131 6.46558 10.3046 6.79052 10.4738C6.27159 10.6733 5.758 10.8433 5.25444 10.9845C5.14763 10.4948 5.06307 9.97597 5.00391 9.43098C5.27563 9.60797 5.55237 9.78248 5.83716 9.94987ZM8.92152 13.2613C8.91829 13.2668 8.91555 13.2725 8.91306 13.2784C8.54043 14.1214 7.85197 14.4409 7.84874 14.4424C7.72195 14.4968 7.60065 14.5232 7.4781 14.5232C6.66814 14.5232 5.84929 13.3241 5.36402 11.4515C6.01803 11.2697 6.68874 11.0399 7.36421 10.764C8.1039 11.1237 8.83396 11.4217 9.5413 11.6553C9.3675 12.2795 9.16053 12.8221 8.92152 13.2613ZM13.8451 11.2375C13.4255 11.8608 12.0177 11.8974 10.1466 11.3441C10.3092 10.671 10.4269 9.94718 10.4955 9.18478C11.139 8.79105 11.7221 8.38553 12.2369 7.97645C12.3713 8.10679 12.4972 8.235 12.615 8.36127C12.4364 8.55901 12.3245 8.81125 12.3245 9.08998C12.3245 9.71438 12.868 10.2224 13.536 10.2224C13.648 10.2224 13.7544 10.2036 13.8574 10.177C13.9838 10.5215 14.0518 10.9304 13.8451 11.2375ZM14.2399 9.08998C14.2399 9.45154 13.9241 9.74558 13.536 9.74558C13.1492 9.74558 12.8346 9.45154 12.8346 9.08998C12.8346 8.72715 13.1492 8.43194 13.536 8.43194C13.9241 8.43194 14.2399 8.72715 14.2399 9.08998ZM14.0967 4.16813C14.4771 4.82822 13.7574 6.05487 12.2606 7.32455C11.735 6.84877 11.1479 6.38306 10.5072 5.93669C10.4461 5.21247 10.3428 4.52507 10.2013 3.88512C10.6469 3.77557 11.0681 3.69549 11.4595 3.64614C11.6019 4.11231 12.0567 4.45658 12.6004 4.45658C13.0797 4.45658 13.4913 4.18918 13.6804 3.80688C13.8714 3.90037 14.012 4.02069 14.0967 4.16813ZM12.6004 2.70549C12.9763 2.70549 13.2822 2.99127 13.2822 3.34258C13.2822 3.69389 12.9763 3.97978 12.6004 3.97978C12.2246 3.97978 11.919 3.69389 11.919 3.34258C11.919 2.99127 12.2246 2.70549 12.6004 2.70549ZM7.4781 0.476797C8.29263 0.476797 9.11423 1.67595 9.59968 3.54862C8.95322 3.72864 8.28254 3.95917 7.59955 4.2382C6.85442 3.87582 6.12295 3.57688 5.41841 3.34423C5.91337 1.5707 6.69345 0.476797 7.4781 0.476797ZM0.762155 5.54858C0.762155 5.19727 1.06778 4.91138 1.44364 4.91138C1.8195 4.91138 2.12537 5.19727 2.12537 5.54858C2.12537 5.89989 1.8195 6.18578 1.44364 6.18578C1.06778 6.18578 0.762155 5.89989 0.762155 5.54858ZM1.44364 4.43458C1.29315 4.43458 1.15044 4.46355 1.01776 4.51135C0.956344 4.20824 0.990219 3.95583 1.12133 3.75989C1.53929 3.13794 2.9453 3.10296 4.81495 3.6559C4.65425 4.32443 4.53723 5.04888 4.46816 5.8173C3.83482 6.20339 3.25137 6.60852 2.72598 7.02472C2.52435 6.8291 2.33408 6.63176 2.15847 6.43429C2.44633 6.23074 2.63549 5.9112 2.63549 5.54858C2.63549 4.93431 2.10071 4.43458 1.44364 4.43458ZM2.70291 7.67561C3.22151 8.14636 3.80876 8.61209 4.45648 9.06327C4.51782 9.78876 4.62109 10.4764 4.76249 11.1154C2.76929 11.6042 1.25034 11.4972 0.864029 10.8266C0.479091 10.1617 1.18321 8.96418 2.70291 7.67561Z" fill="#471966"/>
<path fill="${this.themeColor || '#000'}" d="M7.48169 8.71026C8.22644 8.71026 8.83221 8.14395 8.83221 7.44785C8.83221 6.75186 8.22644 6.18555 7.48169 6.18555C6.73694 6.18555 6.13118 6.75186 6.13118 7.44785C6.13118 8.14395 6.73694 8.71026 7.48169 8.71026ZM7.48169 6.66234C7.94498 6.66234 8.32209 7.0147 8.32209 7.44785C8.32209 7.88099 7.94498 8.23347 7.48169 8.23347C7.0184 8.23347 6.6413 7.88099 6.6413 7.44785C6.6413 7.0147 7.0184 6.66234 7.48169 6.66234Z" fill="#471966"/>
</svg>

        `)
      },
      {
        label: this.user.user.questions[1].questions,
        icon: 'assets/icon/Default_theme/Default_2.svg',
        customSvgPath: 'M4 4h8v2H4V4zm0 4h8v2H4V8zm0 4h8v2H4v-2z',
        iconSvg: this.sanitizer.bypassSecurityTrustHtml(`
         <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="${this.themeColor || '#000'}" d="M12.2814 9.78762L11.1255 8.63178L9.96968 7.47593L8.81797 6.32163L2.85729 0.361472C2.82849 0.332635 2.79428 0.309759 2.75663 0.29415C2.71898 0.278542 2.67862 0.270508 2.63786 0.270508C2.5971 0.270508 2.55674 0.278542 2.51909 0.29415C2.48144 0.309759 2.44723 0.332635 2.41842 0.361472L0.225105 2.55479C0.167023 2.61295 0.134399 2.69178 0.134399 2.77397C0.134399 2.85616 0.167023 2.93499 0.225105 2.99314L12.1413 14.9093C12.1701 14.9382 12.2043 14.961 12.242 14.9767C12.2796 14.9923 12.32 15.0003 12.3607 15.0003C12.4015 15.0003 12.4418 14.9923 12.4795 14.9767C12.5171 14.961 12.5514 14.9382 12.5802 14.9093L14.773 12.716C14.831 12.6579 14.8637 12.579 14.8637 12.4968C14.8637 12.4146 14.831 12.3358 14.773 12.2777L12.2814 9.78762ZM12.3589 14.2513L0.883153 2.77552L2.6376 1.02107L3.53343 1.91639L2.65466 2.79516C2.59724 2.85345 2.56518 2.93207 2.56546 3.01389C2.56575 3.09572 2.59835 3.17411 2.65618 3.232C2.714 3.28989 2.79235 3.32259 2.87418 3.32297C2.956 3.32335 3.03465 3.29138 3.09301 3.23403L3.97179 2.35526L4.68928 3.07223L4.36052 3.40152C4.33004 3.42991 4.3056 3.46415 4.28865 3.5022C4.2717 3.54024 4.26258 3.58131 4.26185 3.62296C4.26111 3.6646 4.26877 3.70597 4.28437 3.74459C4.29997 3.78321 4.32319 3.81829 4.35264 3.84774C4.38209 3.8772 4.41718 3.90041 4.4558 3.91601C4.49442 3.93161 4.53578 3.93927 4.57743 3.93854C4.61907 3.9378 4.66014 3.92869 4.69819 3.91174C4.73623 3.89478 4.77048 3.87034 4.79887 3.83987L5.12815 3.51111L5.84513 4.2286L4.96635 5.10737C4.93719 5.13611 4.914 5.17033 4.89812 5.20807C4.88224 5.24581 4.874 5.28631 4.87385 5.32726C4.87371 5.3682 4.88168 5.40876 4.89729 5.44661C4.9129 5.48446 4.93586 5.51884 4.96482 5.54778C4.99379 5.57671 5.0282 5.59962 5.06607 5.61519C5.10394 5.63076 5.14451 5.63868 5.18545 5.63848C5.22639 5.63829 5.26689 5.63 5.30461 5.61408C5.34233 5.59816 5.37653 5.57493 5.40522 5.54573L6.284 4.66695L7.00098 5.38445L6.67221 5.71321C6.64339 5.74203 6.62054 5.77624 6.60494 5.81389C6.58934 5.85154 6.58132 5.89189 6.58132 5.93265C6.58132 5.9734 6.58934 6.01375 6.60494 6.0514C6.62054 6.08906 6.64339 6.12327 6.67221 6.15208C6.70103 6.1809 6.73524 6.20376 6.77289 6.21935C6.81054 6.23495 6.85089 6.24297 6.89165 6.24297C6.9324 6.24297 6.97275 6.23495 7.0104 6.21935C7.04805 6.20376 7.08226 6.1809 7.11108 6.15208L7.43985 5.8228L8.15734 6.54029L7.27856 7.41907C7.22115 7.47736 7.18909 7.55598 7.18937 7.6378C7.18966 7.71962 7.22226 7.79802 7.28008 7.85591C7.33791 7.9138 7.41626 7.9465 7.49808 7.94688C7.5799 7.94726 7.65856 7.91529 7.71692 7.85794L8.59569 6.97916L9.31319 7.69614L8.98442 8.02542C8.95395 8.05382 8.92951 8.08806 8.91256 8.1261C8.8956 8.16415 8.88649 8.20522 8.88576 8.24686C8.88502 8.28851 8.89268 8.32988 8.90828 8.36849C8.92388 8.40711 8.9471 8.4422 8.97655 8.47165C9.006 8.5011 9.04108 8.52432 9.0797 8.53992C9.11832 8.55552 9.15969 8.56318 9.20133 8.56244C9.24298 8.56171 9.28405 8.5526 9.32209 8.53564C9.36014 8.51869 9.39438 8.49425 9.42278 8.46378L9.75154 8.13501L10.469 8.8525L9.59026 9.73128C9.56109 9.76001 9.5379 9.79423 9.52203 9.83197C9.50615 9.86971 9.4979 9.91022 9.49776 9.95116C9.49762 9.9921 9.50558 10.0327 9.5212 10.0705C9.53681 10.1084 9.55976 10.1427 9.58873 10.1717C9.6177 10.2006 9.65211 10.2235 9.68997 10.2391C9.72784 10.2547 9.76842 10.2626 9.80936 10.2624C9.8503 10.2622 9.8908 10.2539 9.92852 10.238C9.96624 10.2221 10.0004 10.1988 10.0291 10.1696L10.9079 9.29086L11.6249 10.0084L11.2961 10.3371C11.2379 10.3953 11.2052 10.4742 11.2052 10.5566C11.2052 10.6389 11.2379 10.7178 11.2961 10.776C11.3543 10.8342 11.4332 10.8669 11.5156 10.8669C11.5979 10.8669 11.6768 10.8342 11.735 10.776L12.0638 10.4467L12.7812 11.1642L11.9025 12.043C11.8451 12.1013 11.813 12.1799 11.8133 12.2617C11.8136 12.3435 11.8462 12.4219 11.904 12.4798C11.9618 12.5377 12.0402 12.5704 12.122 12.5708C12.2038 12.5712 12.2825 12.5392 12.3408 12.4818L13.2196 11.6031L14.1154 12.4984L12.3589 14.2513Z" fill="#471966"/>
<path fill="${this.themeColor || '#000'}" d="M6.79175 10.4C6.7336 10.342 6.65477 10.3093 6.57258 10.3093C6.49039 10.3093 6.41156 10.342 6.3534 10.4L3.90731 12.8487L3.24977 12.1907L5.69794 9.742C5.75602 9.68385 5.78864 9.60501 5.78864 9.52282C5.78864 9.44063 5.75602 9.3618 5.69794 9.30365C5.66913 9.27481 5.63493 9.25193 5.59727 9.23632C5.55962 9.22072 5.51926 9.21268 5.4785 9.21268C5.43774 9.21268 5.39738 9.22072 5.35973 9.23632C5.32208 9.25193 5.28787 9.27481 5.25907 9.30365L2.8109 11.7518L2.14976 11.0943L4.59895 8.64767C4.6563 8.58931 4.68827 8.51065 4.68789 8.42883C4.68751 8.34701 4.65481 8.26865 4.59692 8.21083C4.53903 8.15301 4.46064 8.1204 4.37881 8.12012C4.29699 8.11983 4.21837 8.15189 4.16008 8.20931L1.49222 10.8767L1.48757 10.8823C1.48456 10.885 1.48179 10.888 1.4793 10.8911L1.46431 10.9097L1.45707 10.919C1.45191 10.9273 1.44674 10.9351 1.44208 10.9433L1.43898 10.949C1.43326 10.9594 1.42825 10.9701 1.42399 10.9811L0.024154 14.5665C0.00441301 14.6147 -0.00331365 14.667 0.00163902 14.7189C0.00659169 14.7707 0.0240755 14.8206 0.0525851 14.8642C0.0920344 14.9223 0.150022 14.9653 0.217066 14.9861C0.28411 15.007 0.356243 15.0045 0.42167 14.979L4.01741 13.576L4.02516 13.5729C4.03943 13.5665 4.05325 13.559 4.06652 13.5507L4.07686 13.5445C4.09171 13.5343 4.10571 13.5229 4.11873 13.5104L4.12235 13.5073L6.78969 10.84C6.81852 10.8111 6.8414 10.7769 6.85701 10.7393C6.87262 10.7016 6.88065 10.6613 6.88065 10.6205C6.88065 10.5798 6.87262 10.5394 6.85701 10.5017C6.8414 10.4641 6.81852 10.4299 6.78969 10.4011L6.79175 10.4ZM0.857439 14.1441L1.83081 11.6489L2.59173 12.4099L3.35264 13.1708L0.857439 14.1441Z" fill="#471966"/>
<path fill="${this.themeColor || '#000'}" d="M8.07111 4.73437C8.09992 4.76321 8.13412 4.78609 8.17178 4.80169C8.20943 4.8173 8.24979 4.82534 8.29055 4.82534C8.33131 4.82534 8.37167 4.8173 8.40932 4.80169C8.44697 4.78609 8.48118 4.76321 8.50998 4.73437L11.6679 1.57647L12.3259 2.234L9.16751 5.39087C9.10943 5.44902 9.07681 5.52785 9.07681 5.61005C9.07681 5.69224 9.10943 5.77107 9.16751 5.82922C9.19632 5.85806 9.23053 5.88094 9.26818 5.89654C9.30583 5.91215 9.34619 5.92019 9.38695 5.92019C9.42771 5.92019 9.46807 5.91215 9.50572 5.89654C9.54337 5.88094 9.57758 5.85806 9.60638 5.82922L12.7643 2.67132L13.4223 3.32937L10.2655 6.48882C10.2366 6.51763 10.2138 6.55183 10.1981 6.58948C10.1825 6.62714 10.1745 6.6675 10.1745 6.70826C10.1745 6.74901 10.1825 6.78937 10.1981 6.82703C10.2138 6.86468 10.2366 6.89889 10.2655 6.92769C10.3236 6.98577 10.4025 7.0184 10.4846 7.0184C10.5668 7.0184 10.6457 6.98577 10.7038 6.92769L14.0814 3.55009L14.6655 2.96597C15.0837 2.54777 15.1137 1.89696 14.7317 1.51496L13.4839 0.268129C13.1018 -0.11388 12.45 -0.0838984 12.0328 0.333778L11.4487 0.918422L8.07111 4.29602C8.01303 4.35417 7.98041 4.433 7.98041 4.5152C7.98041 4.59739 8.01303 4.67622 8.07111 4.73437Z" fill="#471966"/>
</svg>

        `)
      },
      {
        label: this.user.user.questions[2].questions,
        icon: 'assets/icon/Default_theme/Default_3.svg',
        customSvgPath: 'M3 3h10v10H3z',
        iconSvg: this.sanitizer.bypassSecurityTrustHtml(`
         <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="${this.themeColor || '#000'}" d="M14.0444 0H1.95556C0.871111 0 0 0.817778 0 1.83111V11.0222C0 12.0356 0.871111 12.8533 1.95556 12.8533H3.23556V15.5733C3.23556 15.7333 3.34222 15.8933 3.50222 15.9644C3.57333 16 3.62667 16 3.69778 16C3.80444 16 3.91111 15.9644 4 15.9111L8.03556 12.8533H14.0444C15.1289 12.8533 16 12.0356 16 11.0222V1.83111C16 0.817778 15.1289 0 14.0444 0ZM15.0933 11.0044C15.0933 11.5378 14.6311 11.9644 14.0622 11.9644H7.85778C7.75111 11.9644 7.64444 12 7.55556 12.0533L4.16 14.6311V12.3911C4.16 12.16 3.94667 11.9644 3.69778 11.9644H1.95556C1.38667 11.9644 0.924444 11.5378 0.924444 11.0044V1.86667C0.924444 1.33333 1.38667 0.906667 1.95556 0.906667H14.08C14.6489 0.906667 15.1111 1.33333 15.1111 1.86667V11.0044H15.0933Z" fill="#471966"/>
<path fill="${this.themeColor || '#000'}" d="M4.62221 6.70267H7.14665V5.81378H4.62221V4.71155H7.35999V3.78711H3.55554V8.97822H7.48443V8.036H4.62221V6.70267Z" fill="#471966"/>
<path fill="${this.themeColor || '#000'}" d="M11.5199 7.41378L9.45772 3.78711H8.31995V8.97822H9.33328V5.29822L11.4488 8.97822H12.5333V3.78711H11.5199V7.41378Z" fill="#471966"/>
</svg>

        `)
      },
      {
        label: this.user.user.questions[3].questions,
        icon: 'assets/icon/Default_theme/Default_4.svg',
        customSvgPath: 'M5 5h6v6H5z',
        iconSvg: this.sanitizer.bypassSecurityTrustHtml(`
          <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill="${this.themeColor || '#000'}" fill-rule="evenodd" clip-rule="evenodd" d="M9.73151 0.376318C9.73151 0.376318 9.69712 0.0015686 10.1069 0.0015686C11.1398 0.0015686 11.977 0.839661 11.977 1.87459V1.876C11.977 2.91167 11.1391 3.75119 10.1055 3.75119C9.89918 3.75119 9.73147 3.58315 9.73147 3.37644V3.75119C9.73147 3.87353 9.67253 3.98813 9.57218 4.05774L8.94274 4.50069L9.57218 4.94363C9.61358 4.97176 9.64726 5.00832 9.67323 5.0484C9.7855 5.03363 9.89988 5.0259 10.015 5.0259C10.709 5.0259 11.3749 5.30293 11.8662 5.79439C12.1665 6.09462 11.8676 6.32523 11.8676 6.32523L9.74977 8.44719C9.74346 8.45351 9.73785 8.45914 9.73083 8.46476V11.5808C9.73644 11.4817 9.78486 11.2504 10.1062 11.2504C11.1392 11.2504 11.9763 12.0885 11.9763 13.1234V13.1248C11.9763 14.1605 11.1384 15 10.1048 15C9.8985 15 9.73079 14.832 9.73079 14.6253H2.24554C2.24554 14.832 2.07783 15 1.87153 15C0.837896 15 3.59768e-05 14.1605 3.59768e-05 13.1248V13.1234C3.59768e-05 12.0884 0.837196 11.2504 1.87009 11.2504C2.19219 11.2504 2.2399 11.4824 2.2455 11.5808V9.74993C2.2455 9.65009 2.2855 9.55517 2.35497 9.48415L2.83916 8.99971L2.35497 8.51527C2.2855 8.44496 2.2455 8.34934 2.2455 8.24949V3.37487C2.2455 3.58158 2.07779 3.74962 1.87149 3.74962C0.83786 3.74962 0 2.9101 0 1.87443V1.87303C0 0.838056 0.83716 0 1.87006 0C2.28057 0 2.24547 0.374749 2.24547 0.374749H9.73072L9.73151 0.376318ZM1.49823 12.0648V14.1875C1.06176 14.0328 0.749491 13.6159 0.749491 13.1265V13.1251C0.749491 12.6357 1.06246 12.2195 1.49823 12.0655V12.0648ZM10.4802 12.0648V14.1875C10.9167 14.0328 11.229 13.6159 11.229 13.1265V13.1251C11.229 12.6357 10.916 12.2195 10.4802 12.0655V12.0648ZM2.24697 12.3763V13.876H9.73222V12.3763H2.24697ZM8.98348 3.37656H2.99571V8.09585L3.63498 8.73567C3.78094 8.88262 3.78094 9.11957 3.63498 9.26651L2.99571 9.90634V11.6261H8.98348V8.55777H8.80174V9.2433C8.80174 9.34314 8.76315 9.43805 8.69227 9.50908C8.69227 9.50908 8.2951 9.90703 7.89722 10.3057C7.61653 10.5869 7.2362 10.7444 6.83973 10.7444C6.57027 10.7444 6.30783 10.672 6.07906 10.5363L5.25173 11.366C5.10577 11.5122 4.86859 11.5122 4.72263 11.366C4.57597 11.2197 4.57597 10.9821 4.72263 10.8359L5.54997 10.0062C5.41524 9.77768 5.34297 9.51471 5.34297 9.24401C5.34297 8.84677 5.50086 8.46498 5.78154 8.18374C6.42924 7.53477 7.36392 6.59753 8.16393 5.79665C8.3548 5.6047 8.57233 5.4465 8.8074 5.32346L8.07621 4.80878C7.97657 4.73917 7.91692 4.62457 7.91692 4.50223C7.91692 4.37989 7.97657 4.26529 8.07621 4.19568L8.98354 3.55726L8.98348 3.37656ZM6.31062 9.77412C6.16957 9.6342 6.09097 9.44296 6.09097 9.24398C6.09097 9.045 6.16956 8.85445 6.31062 8.71384L8.69301 6.32675C9.04386 5.9752 9.51964 5.77762 10.0158 5.77762C10.3856 5.77762 10.7441 5.88731 11.0473 6.0891L9.33087 7.8089H8.42777C8.22147 7.8089 8.05376 7.97694 8.05376 8.18365V9.08854L7.36888 9.77547C7.22924 9.91539 7.03908 9.99413 6.84048 9.99413C6.64189 9.99413 6.45242 9.91538 6.31209 9.77547L6.31139 9.77406L6.31062 9.77412ZM1.49823 0.815775V2.93845C1.06176 2.78377 0.749491 2.36683 0.749491 1.87747V1.87607C0.749491 1.3867 1.06246 0.970479 1.49823 0.816493V0.815775ZM10.4802 0.815775V2.93845C10.9167 2.78377 11.229 2.36683 11.229 1.87747V1.87607C11.229 1.3867 10.916 0.970479 10.4802 0.816493V0.815775ZM9.73151 2.62688V1.12717H2.24625V2.62688H9.73151Z" fill="#471966"/>
</svg>

        `)
      }
    ];
  }

  updateIconsByTheme() {

    if (
      this.themeApplied === 'camp_wings' ||
      this.themeApplied === 'spin_and_swing' ||
      this.themeApplied === 'cricket_fever' ||
      this.themeApplied === 'learning_lane' ||
      this.themeApplied === 'jump_shot'
    ) {
      this.suggestionChips = [
        {
          icon: 'assets/icon/Other_theme/Suggestion_quetion_1.svg',
          // label: "Explain Newton's Laws in simple terms.",
          customSvgPath: ""
        },
        {
          icon: 'assets/icon/Other_theme/Suggestion_quetion_2.svg',
          // label: "Solve a quadratic equation: x² + 5x + 6 = 0",
          customSvgPath: ""
        },
        {
          icon: 'assets/icon/Other_theme/Suggestion_quetion_3.svg',
          // label: "Help me with my English essay.",
          customSvgPath: ""
        },
        {
          icon: 'assets/icon/Other_theme/Suggestion_quetion_4.svg',
          // label: "What are the key features of the Constitution?",
          customSvgPath: ""
        }
      ];
    } else if (this.themeApplied === 'nebula_way') {
      this.suggestionChips = [
        {
          icon: 'assets/icon/Dark_theme/Suggestion_quetion_1.svg',
          // label: "Explain Newton's Laws in simple terms.",
          customSvgPath: ""
        },
        {
          icon: 'assets/icon/Dark_theme/Suggestion_quetion_2.svg',
          // label: "Solve a quadratic equation: x² + 5x + 6 = 0",
          customSvgPath: ""
        },
        {
          icon: 'assets/icon/Dark_theme/Suggestion_quetion_3.svg',
          // label: "Help me with my English essay.",
          customSvgPath: ""
        },
        {
          icon: 'assets/icon/Dark_theme/Suggestion_quetion_4.svg',
          // label: "What are the key features of the Constitution?",
          customSvgPath: ""
        }
      ];
    } else {
      this.suggestionChips = [
        {
          icon: 'assets/icon/Default_theme/Default_1.svg',
          // label: "Explain Newton's Laws in simple terms.",
          customSvgPath: ""
        },
        {
          icon: 'assets/icon/Default_theme/Default_2.svg',
          // label: "Solve a quadratic equation: x² + 5x + 6 = 0",
          customSvgPath: ""
        },
        {
          icon: 'assets/icon/Default_theme/Default_3.svg',
          // label: "Help me with my English essay.",
          customSvgPath: ""
        },
        {
          icon: 'assets/icon/Default_theme/Default_4.svg',
          // label: "What are the key features of the Constitution?",
          customSvgPath: ""
        }
      ];

    }
  }
  setGreeting(): void {
    const hour = new Date().getHours();

    if (hour < 12) {
      this.greetingMessage = 'Good Morning ';
      if (this.themeApplied === 'nebula_way') {
        this.greetingIcon = 'assets/icon/Dark_theme/greetingsIconDarkthemeMorning.svg';
      } else {
        this.greetingIcon = 'assets/icon/Default_theme/GreetingsiconMorninglighttheme.svg';
      }
    } else if (hour < 18) {
      this.greetingMessage = 'Good Afternoon ';
      if (this.themeApplied === 'nebula_way') {
        this.greetingIcon = 'assets/icon/Dark_theme/greetingsIconDarkthemeMorning.svg';
      } else {
        this.greetingIcon = 'assets/icon/Default_theme/GreetingsiconMorninglighttheme.svg';
      }
    } else {
      this.greetingMessage = 'Good Evening ';
      if (this.themeApplied === 'nebula_way') {
        this.greetingIcon = 'assets/icon/Dark_theme/greetingsIconDarkthemeMorning.svg';
      } else {
        this.greetingIcon = 'assets/icon/Default_theme/GreetingsiconMorninglighttheme.svg';
      }
    }
  }

  get isDarkMode(): boolean {
    return this.themeService.getCurrentTheme()
  }

  convertChatsToMessages(chats: Chat[]): ChatMessage[] {
    return chats.flatMap((chat) => [
      {
        content: chat.query,
        Text: chat.query,
        sender: "user",
        timestamp: new Date(chat.timestamp),
        sessionId: chat.sessionId || "", // ✅ Ensure sessionId is included
        audioUrl: undefined, // ✅ Explicitly set audioUrl for user messages
      },
      {
        content: chat.response,
        Text: chat.response,
        sender: "ai",
        timestamp: new Date(chat.timestamp),
        sessionId: chat.sessionId || "", // ✅ Ensure sessionId is included
        audioUrl: chat.audio_url || undefined, // ✅ Handle audioUrl properly
      },
    ]);
  }

  loadChatMessages(sessionId: string): void {
    var pageNumber = 1
    this.chatService.getChatHistory(pageNumber, this.user.user.id, sessionId).subscribe(
      (history: any) => {
        console.log(history, 'history')
        this._selectedChat = history.data[0];
        this.messages = this.convertChatsToMessages(history.data[0].chats || []);
        this.groupedMessages = this.groupMessagesByDateHistory(this.messages);
        console.log(this.groupedMessages, 'grouped message')
        // this.messages = this.convertChatsToMessages(chatSession.chats || []);
      },
      (error) => {
        // console.error("Failed to load chat messages:", error);
        // this.messages = [{
        //   content: "Unable to load messages.",
        //   sender: "system",
        //   timestamp: new Date(),
        //   sessionId,
        // }];
      }
    );
  }

  thinkingSubscription?: Subscription;
  thinkingTimeout: any;

  sendMessage(): void {
    if (this.subscriptionExpired) return;

    if (!this.isMoved) {
      this.isMoved = true;
    }


    if (this.chatForm.valid && !this.isTyping) {
      this.stopAudio();
      const userMessage = this.chatForm.get("message")?.value;
      const currentTime = new Date();
      // this.shouldScroll = true;


      const userId = this.user.user.id;

      // Use the stored session ID if available, otherwise check _selectedChat
      const sessionId = this.sessionId;

      // Send empty string for a new chat

      // Add user message to chat
      this.messages.push({
        content: userMessage,
        Text: userMessage,
        sender: "user",
        timestamp: currentTime,
        sessionId: this.sessionId || "", // ✅ Ensure sessionId is included
        // type: "text", // ✅ Add a type field for future scalability

      });


      this.chatForm.reset();
      setTimeout(() => this.autoResizeTextarea(), 0);
      this.isTyping = true;
      this.shouldScroll = true;
      console.log(this.user.user.studentClass.grade, 'chat component')
      const collectionName = this.classToCollectionMap[this.user.user.studentClass.grade];
      
      // Prepare request payload
      const requestData: any = {
        userId: userId,
        sessionId: sessionId, // Empty if new chat
        query: userMessage,
        collection_name: collectionName,
        api_auth_key: '123456789',
        search_type: 'similarity',
        school_id: this.user.user.schoolId
      };

      // Add debug and no_cache parameters for development and staging
      if (!environment.production) {
        requestData.debug = "true";
        requestData.no_cache = "true";
        console.log('Debug mode enabled - Request payload:', requestData);
      }


      // Simulate AI typing
      this.thinkingTimeout = setTimeout(() => {
        this.thinkingSubscription = this.chatService.sendMessage(requestData).subscribe(
          (response: any) => {
            this.isTyping = false;
            this.fullMessage = response.content as string;
            this.displayedMessage = "";
            this.wordIndex = 0;
            this.stopRevealing();
            this.revealWords();

            if (!this.sessionId && response.sessionId) {
              this.sessionId = response.sessionId;
            }

            this.chatService.notifyChatUpdated();
            this.messages.push({
              ...response,
              content: "",
            });
            setTimeout(() => {
              this.chatService.triggerRefresh();
            }, 3000);
            this.shouldScroll = true; // ✅ FIX: trigger scroll after message is pushed
            // this.scrollToBottom();
          },
          (error) => {
            console.error("Error:", error);
            this.isTyping = false;
            
            // Handle trial expired (403) specifically
            if (error.status === 403 && error.error?.reason === 'trial_expired') {
              const trialWarning = error.error.warning || 'Your trial period is over, please upgrade to a paid plan.';
              const validTill = error.error.trial_valid_till ? new Date(error.error.trial_valid_till).toLocaleDateString() : '';
              
              Swal.fire({
                icon: 'warning',
                title: 'Trial Period Expired',
                html: `
                  <p>${trialWarning}</p>
                  ${validTill ? `<p style="font-size: 14px; color: #666;">Trial ended on: ${validTill}</p>` : ''}
                  <p style="font-size: 13px; color: #888; margin-top: 12px;">Please contact your school administrator to upgrade your plan.</p>
                `,
                confirmButtonText: 'OK',
                confirmButtonColor: '#8c52ff'
              });
              
              // Add message to chat showing trial expired
              this.messages.push({
                content: `⚠️ ${trialWarning}`,
                Text: trialWarning,
                sender: "ai",
                timestamp: new Date(),
                sessionId: this.sessionId || "",
              });
            } else {
              // Handle other errors
              this.messages.push({
                content: error.error?.answer || "Sorry, there was an error processing your request.",
                Text: "Sorry, there was an error processing your request.",
                sender: "ai",
                timestamp: new Date(),
                sessionId: this.sessionId || "",
              });
            }

            this.shouldScroll = true; // ✅ also scroll in error case
          }
        );

      }, 1000);
    }
  }

  // sendMessage(): void {
  //   if (this.chatForm.valid && !this.isTyping) {
  //     const userMessage = this.chatForm.get("message")?.value
  //     const currentTime = new Date()
  //     this.shouldScroll = true;
  //     // Add user message
  //     this.messages.push({
  //       content: userMessage,
  //       Text:userMessage,
  //       sender: "user",
  //       timestamp: currentTime,
  //     })

  //     this.chatForm.reset()
  //     this.isTyping = true

  //     // Simulate AI typing
  //     setTimeout(() => {
  //       this.chatService.sendMessage(userMessage).subscribe(
  //         (response) => {
  //           this.isTyping = false
  //           this.fullMessage = response.content as string
  //           this.displayedMessage = ""
  //           this.wordIndex = 0
  //           this.revealWords()
  //           this.messages.push({
  //             ...response,
  //             content: "",
  //           })
  //         },
  //         (error) => {
  //           console.error("Error:", error)
  //           this.isTyping = false
  //           this.messages.push({
  //             content: "Sorry, there was an error processing your request.",
  //             sender: "ai",
  //             Text:"Sorry, there was an error processing your request.",
  //             timestamp: new Date(),
  //           })
  //         },
  //       )
  //     }, 1000)
  //   }
  // }

  revealWords(): void {
    this.isRevealing = true;

    this.revealInterval = setInterval(() => {
      const words = this.fullMessage.split(" ");

      if (this.wordIndex < words.length) {
        this.displayedMessage += (this.wordIndex > 0 ? " " : "") + words[this.wordIndex];
        this.wordIndex++;
        this.updateLastMessage();

        // ✅ Only scroll if user is at the bottom (i.e., has not scrolled up)
        this.scrollToBottom(this.autoScrollEnabled); // It internally checks `shouldScroll`
      } else {
        clearInterval(this.revealInterval);
        this.isRevealing = false;
      }
    }, 100);
  }

  private isUserScrolling = false;

  lastScrollTop = 0;
  onScroll(): void {
    if (this.isProgrammaticScroll) {
      console.log('🚫 Ignored programmatic scroll');
      return;
    }

    const el = this.chatContent.nativeElement;
    const threshold = 20;
    const isAtBottom = el.scrollHeight - el.scrollTop - el.clientHeight < threshold;

    if (this.autoScrollEnabled && !isAtBottom) {
      console.log('🛑 User scrolled up — disabling auto-scroll');
      this.autoScrollEnabled = false;
    } else if (!this.autoScrollEnabled && isAtBottom) {
      console.log('✅ User reached bottom — enabling auto-scroll');
      this.autoScrollEnabled = true;
    }
  }

  stopRevealing(): void {
    clearInterval(this.revealInterval);
    this.isRevealing = false; // Stop revealing words
  }
  updateLastMessage(): void {
    if (this.messages.length > 0) {
      this.messages[this.messages.length - 1].content = this.displayedMessage
    }
  }

  formatAndUpdateLastMessage(): void {
    if (this.messages.length > 0) {
      const formattedContent = this.formatMessage(this.fullMessage)
      this.messages[this.messages.length - 1].content = formattedContent
    }
  }
  // ngAfterViewChecked(): void {
  //   if (typeof MathJax !== 'undefined') {
  //     MathJax.typesetPromise(); // Render math
  //   }
  // }

  // formatMessage(content: string): SafeHtml {
  //   // Step 1: Normalize line endings and trim input
  //   let formatted = content.trim().replace(/\r\n/g, "\n");

  //   // Step 2: Handle bold (**bold**)
  //   formatted = formatted.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

  //   // Step 3: Handle inline code (`code`)
  //   formatted = formatted.replace(/`(.*?)`/g, "<code>$1</code>");

  //   // Step 4: Format numbered lists (1. Item)
  //   formatted = formatted.replace(/(?:^|\n)(\d+\.\s.+)/g, "\n<li>$1</li>");
  //   formatted = formatted.replace(/(<li>\d+\..+<\/li>\s*)+/g, match => `<ol>${match.trim()}</ol>`);

  //   // Step 5: Format unordered lists (- item or * item)
  //   formatted = formatted.replace(/(?:^|\n)[\-\*]\s(.+)/g, "\n<li>$1</li>");
  //   formatted = formatted.replace(/(<li>.+<\/li>\s*)+/g, match => {
  //     return match.includes("<ol>") ? match : `<ul>${match.trim()}</ul>`;
  //   });

  //   // // Step 6: Format LaTeX block equations (surrounded by $$...$$ or \[...\])
  //   // formatted = formatted.replace(/\$\$(.*?)\$\$/gs, (_, eq) => `<div>\\[${eq.trim()}\\]</div>`);
  //   // formatted = formatted.replace(/\\\[(.*?)\\\]/gs, (_, eq) => `<div>\\[${eq.trim()}\\]</div>`);

  //   // // Step 7: Format inline LaTeX math (surrounded by \( ... \) or $...$)
  //   // formatted = formatted.replace(/(?<!\\)\$(.+?)(?<!\\)\$/g, (_, eq) => `<span>\\(${eq.trim()}\\)</span>`);
  //   // formatted = formatted.replace(/\\\((.*?)\\\)/g, (_, eq) => `<span>\\(${eq.trim()}\\)</span>`);

  //   // Step 8: Replace paragraph breaks and line breaks
  //   formatted = formatted.replace(/\n{2,}/g, "<br><br>");
  //   formatted = formatted.replace(/\n/g, "<br>");

  //   // Step 9: Clean <br> between list tags
  //   formatted = formatted.replace(/<br>(?=<\/?li>)/g, "");

  //   return this.sanitizer.bypassSecurityTrustHtml(formatted);
  // }
  fixLatex(latex: string): string {
    let fixed = latex;

    // Fix duplicate subscripts: I_1_1 → I_1
    fixed = fixed.replace(/([A-Za-z])_(\d+)_\d+/g, '$1_$2');

    // Remove nested \frac{\frac{...}} → \frac{...}
    while (/\\frac{\\frac{([^{}]+)}}/.test(fixed)) {
      fixed = fixed.replace(/\\frac{\\frac{([^{}]+)}}/g, '\\frac{$1}');
    }

    // Balance braces
    const openBraces = (fixed.match(/{/g) || []).length;
    const closeBraces = (fixed.match(/}/g) || []).length;
    if (openBraces > closeBraces) {
      fixed += '}'.repeat(openBraces - closeBraces);
    }
    if (closeBraces > openBraces) {
      fixed = fixed.replace(/}+$/g, '');
    }

    return fixed.trim();
  }

  formatMessage(content: string): SafeHtml {
    let formatted = content.trim();

    // --- Escape HTML ---
    formatted = formatted
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

    // --- Preserve code blocks ---
    const preBlocks: string[] = [];
    formatted = formatted.replace(/```([\s\S]*?)```/g, (_, code) => {
      preBlocks.push(`<pre><code>${code.trim()}</code></pre>`);
      return `@@CODEBLOCK${preBlocks.length - 1}@@`;
    });

    // --- Bold headings (## Heading or Step X:) ---
    formatted = formatted.replace(/^##\s*(.+)$/gm, (_, text) => `<strong>${text.trim()}</strong>`);
    formatted = formatted.replace(/Step (\d+):/g, (_, stepNum) =>
      `<br/><strong>Step ${stepNum}:</strong><br/>`
    );

    // --- Wrap numbered steps’ content in paragraphs ---
    formatted = formatted.replace(
      /(<strong>Step \d+:<\/strong><br\/>)([^<]+)/g,
      (_, heading, text) => `${heading}<p>${text.trim()}</p>`
    );

    // --- Bold text: **text** ---
    formatted = formatted.replace(/\*\*(.+?)\*\*/g, (_, text) => `<strong>${text}</strong>`);

    // --- Numbered lists (CORRECT) ---
    formatted = formatted.replace(
      /(?:^\d+\.\s+.+$(?:\n\s*)?)+/gm,
      (match) => {
        const items = match
          .trim()
          .split(/\n+/)
          .filter(line => /^\d+\.\s+/.test(line))
          .map(line => line.replace(/^\d+\.\s+/, "").trim())
          .map(text => `<li>${text}</li>`)
          .join("");
        return `<ol>${items}</ol>`;
      }
    );

    // --- Preserve ordered lists (IMPORTANT) ---
    const olBlocks: string[] = [];
    formatted = formatted.replace(/<ol>[\s\S]*?<\/ol>/g, (match) => {
      olBlocks.push(match);
      return `@@OLBLOCK${olBlocks.length - 1}@@`;
    });

    // --- Paragraph wrapping ---
    formatted = formatted
      .split(/\n{2,}/)
      .map(line => {
        const trimmed = line.trim();
        if (!trimmed) return "";
        if (
          trimmed.startsWith("<strong>") ||
          trimmed.startsWith("<pre>") ||
          trimmed.startsWith("@@OLBLOCK") ||
          trimmed.startsWith('<div class="step"') ||
          // Keep LaTeX environments (e.g. matrix/determinant) unwrapped so MathJax can render them.
          trimmed.startsWith("\\begin{")
        ) {
          return trimmed;
        }
        return `<p>${trimmed}</p>`;
      })
      .join("");

    // --- Restore ordered lists ---
    formatted = formatted.replace(/@@OLBLOCK(\d+)@@/g, (_, i) => olBlocks[+i]);

    // --- Restore code blocks ---
    formatted = formatted.replace(/@@CODEBLOCK(\d+)@@/g, (_, i) => preBlocks[+i]);

    // --- Auto-wrap common matrix/determinant LaTeX environments for MathJax ---
    formatted = formatted.replace(
      /\\begin\{(vmatrix|bmatrix|matrix|pmatrix)\}([\s\S]*?)\\end\{\1\}/g,
      (_, env, inner) => {
        const cleanedInner = this.fixLatex(String(inner));
        return `<div class="mathjax-block">\\[\\begin{${env}}${cleanedInner}\\end{${env}}\\]</div>`;
      }
    );

    // --- MathJax block ---
    formatted = formatted.replace(/\$\$(.+?)\$\$/gs, (_, mathContent) => {
      const cleaned = this.fixLatex(mathContent);
      return `<div class="mathjax-block">\\[${cleaned}\\]</div>`;
    });

    // --- MathJax inline ---
    formatted = formatted.replace(/\$(.+?)\$/g, (_, mathContent) => {
      const cleaned = this.fixLatex(mathContent);
      return `<span class="mathjax-inline">\\(${cleaned}\\)</span>`;
    });

    // --- Trigger MathJax render ---
    if ((window as any).MathJax) {
      (window as any).MathJax.typesetPromise();
    }

    return this.sanitizer.bypassSecurityTrustHtml(formatted);
  }

  onEnter(event: Event) {
    if (this.subscriptionExpired) return;
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    if (!this.isRevealing) {
      this.sendMessage();
    } else {
      console.log('Bot is still responding. Stop first to send a new message.');
    }
  }

  // --- Helper: check for balanced braces ---
  hasBalancedBraces(latex: string): boolean {
    let count = 0;
    for (const char of latex) {
      if (char === '{') count++;
      if (char === '}') count--;
      if (count < 0) return false; // extra closing brace
    }
    return count === 0;
  }


  // --- Helper: Check unbalanced braces ---
  hasUnbalancedBraces(latex: string): boolean {
    let stack = 0;
    for (const char of latex) {
      if (char === '{') stack++;
      else if (char === '}') stack--;
      if (stack < 0) return true; // extra closing brace
    }
    return stack !== 0; // true if braces are unbalanced
  }

  // --- Helper: Fix common LaTeX issues ---


  // playAudio(audioUrl: string): void {
  //   if (!audioUrl) {
  //     console.error("Error: Audio URL is empty or undefined.");
  //     return;
  //   }

  //   if (this.currentAudio) {
  //     // If audio is already loaded, just play it
  //     this.currentAudio.play().catch((error) => {
  //       console.error("Error playing audio:", error);
  //       this.audioError = true;
  //     });
  //   } else {
  //     // If no audio is loaded, create a new Audio object
  //     console.log("Playing audio from:", audioUrl);
  //     this.currentAudio = new Audio(audioUrl);
  //     this.currentAudio.load();

  //     this.currentAudio.play()
  //       .then(() => {
  //         this.isPlayingAudio = true;
  //         this.audioError = false;
  //         console.log("Audio is playing", this.isPlayingAudio); // Should log true when playing
  //       })
  //       .catch((error) => {
  //         console.error("Error playing audio:", error);
  //         this.audioError = true;
  //         this.isPlayingAudio = false;
  //       });
  //   }
  // }

  // stopAudio(): void {
  //   if (this.currentAudio) {
  //     console.log("Stopping audio");
  //     this.currentAudio.pause();
  //     this.currentAudio.currentTime = 0; // Reset audio to the beginning
  //     this.currentAudio = null; // Release the audio resource
  //     this.isPlayingAudio = false;
  //   } else {
  //     console.error("No audio to stop");
  //   }
  // }

  // toggleAudio(text: any, event: Event): void {
  //   event.stopPropagation();
  //   var tempAudio=this.formatMessage(text)
  //   this.shouldScroll = false;
  //   if (this.playingMessageText === text) {
  //     // If the same message is playing, stop it
  //     this.stopAudio();
  //   } else {
  //     // Play new audio
  //     this.playAudio(tempAudio);
  //   }
  // }
  // toggleAudio(text: any, event: Event): void {
  //   event.stopPropagation();

  //   // Convert SafeHtml to a string


  //   this.shouldScroll = false;

  //   if (this.playingMessageText === text) {
  //     // If the same message is playing, stop it
  //     this.stopAudio();
  //   } else {
  //     // Play new audio
  //     if (text) {
  //       // this.playingMessageText = text; // Set the playing message
  //       this.playAudio(text);
  //     }
  //   }
  // }
  toggleAudio(url: string, event: Event): void {
    event.stopPropagation();
    console.log("toggleAudio called with URL:", url);
    this.shouldScroll = false;

    if (this.playingMessageUrl === url) {
      // If the same audio is playing, stop it
      this.stopAudio();
    } else {
      // Stop previous if any
      this.stopAudio();

      if (url) {

        this.playAudio(url);
        this.playingMessageUrl = url;
      } else {
        console.warn("toggleAudio called with no URL");
      }
    }
  }
  playAudio(url: string): void {
    if (!url) {
      console.error("playAudio called with empty URL");
      return;
    }
    console.log("Attempting to play audio:", url);
    this.audio = new Audio(url);
    this.audio.play()
      .then(() => {
        console.log("Audio playback started successfully");
      })
      .catch((err) => {
        console.error("Audio playback failed:", err);
        this.playingMessageUrl = null;
      });

    this.audio.onended = () => {
      console.log("Audio playback ended");
      this.playingMessageUrl = null;
    };
  }

  stopAudio(): void {
    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
    }
    this.playingMessageUrl = null;
  }
  getTimeString(date: Date): string {
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
  }

  useChip(suggestion: string): void {
    if (this.subscriptionExpired) return;
    this.chatForm.patchValue({ message: suggestion })
  }

  toggleFullscreen(): void {
    console.log("Toggle fullscreen")
  }

  toggleUserMenu(): void {
    console.log("Toggle user menu")
  }

  toggleTheme(): void {
    this.themeService.toggleTheme()
  }

  // private applyTheme(isDark: boolean): void {
  //   const savedTheme = localStorage.getItem('theme') || 'light'; // Default to light
  //   document.body.classList.toggle('dark', savedTheme === 'dark');
  //   if (isDark) {
  //     this.renderer.addClass(this.el.nativeElement, "dark-theme")
  //     this.renderer.removeClass(this.el.nativeElement, "light-theme")
  //   } else {
  //     this.renderer.addClass(this.el.nativeElement, "light-theme")
  //     this.renderer.removeClass(this.el.nativeElement, "dark-theme")
  //   }
  // }
  private applyTheme(): void {
    this.themeApplied = this.user.user.theme.name;
    this.themeColor = this.user?.user?.theme?.customTheme?.accentColor;
    this.primaryColor = this.user?.user?.theme?.customTheme?.primaryColor;
    if (this.enableStudentThemes) {
      this.normalizedThemeName = normalizeStudentThemeName(this.themeApplied);
      this.juniorThemeActive = isJuniorStudentTheme(this.normalizedThemeName);
      const themeVisual = getStudentThemeVisual(this.normalizedThemeName);
      this.chatThemeClass = themeVisual.chatClass;
      document.documentElement.style.setProperty('--student-theme-accent', themeVisual.accent);
      document.documentElement.style.setProperty('--student-theme-primary', themeVisual.primary);
      document.documentElement.style.setProperty('--student-theme-surface', themeVisual.surface);
      document.documentElement.style.setProperty('--student-theme-surface-alt', themeVisual.surfaceAlt);
      document.documentElement.style.setProperty('--student-theme-border', themeVisual.border);
      document.documentElement.style.setProperty('--student-theme-chip', themeVisual.chip);
    } else {
      this.normalizedThemeName = 'default';
      this.juniorThemeActive = false;
      this.chatThemeClass = 'student-chat-default';
    }

    const allThemes = ['light-theme', 'dark-theme', 'space-theme', 'cricket-theme', 'sunset-theme', 'camp_wings', 'jump_shot'];

    // Remove all existing theme classes from body
    allThemes.forEach(theme => this.renderer.removeClass(document.body, theme));

    switch (this.themeApplied) {

      case 'nebula_way':
        this.renderer.addClass(document.body, 'dark-theme');
        this.isLightTheme = false;
        break;
      case 'spin_and_swing':
        this.renderer.addClass(document.body, 'light-theme');
        this.renderer.addClass(document.body, 'cricket-theme');
        this.isLightTheme = true;
        break;
      case ' learning_lane':
        this.renderer.addClass(document.body, '');
        this.renderer.addClass(document.body, 'light-theme');
        this.isLightTheme = false;
        break;
      case 'cricket_fever':
        this.renderer.addClass(document.body, 'cricket-theme');
        this.isLightTheme = true;
        break;
      case 'camp_wings':
        this.renderer.addClass(document.body, 'camp_wings');
        this.renderer.addClass(document.body, 'light-theme');
        this.isLightTheme = false;
        break;
      case 'jump_shot':
        this.renderer.addClass(document.body, 'jump_shot');
        this.renderer.addClass(document.body, 'light-theme');
        this.isLightTheme = true;
        break;
      // case 'rainbow':
      // case 'mango':
      // case 'rocket':
      // case 'ice_cream':
      // case 'learning_lane':
      // case 'default':
      //   this.renderer.addClass(document.body, 'light-theme');
      //   this.isLightTheme = true;
      //   break;
      default:
        this.renderer.addClass(document.body, 'light-theme');
        this.isLightTheme = true;
    }
    this.setGreeting();
    document.documentElement.style.setProperty('--primary-color', this.themeColor);
  }
  initSpeechRecognition(): void {
    if ("webkitSpeechRecognition" in window) {
      this.recognition = new window.webkitSpeechRecognition()
      this.recognition.continuous = false
      this.recognition.interimResults = false

      this.recognition.onresult = (event: any) => {
        const transcript = event.results[0][0].transcript
        this.ngZone.run(() => {
          this.chatForm.patchValue({ message: transcript })
        })
      }

      this.recognition.onerror = (event: any) => {
        console.error("Speech recognition error", event.error)
        this.ngZone.run(() => {
          this.isListening = false
        })
      }

      this.recognition.onend = () => {
        this.ngZone.run(() => {
          this.isListening = false
        })
      }
    } else {
      console.warn("Speech recognition not supported in this browser")
    }
  }

  toggleSpeechRecognition(): void {
    if (this.isListening) {
      this.recognition.stop()
    } else {
      this.recognition.start()
    }
    this.isListening = !this.isListening
  }

  // Math Keyboard Methods
  toggleMathKeyboard(): void {
    this.showMathKeyboard = !this.showMathKeyboard;
    if (this.showMathKeyboard) {
      // Scroll to show input + keyboard when keyboard opens (delay for ngIf to render)
      setTimeout(() => {
        this.scrollToKeyboard();
      }, 150);
    }
  }

  scrollToKeyboard(): void {
    const keyboardEl = this.mathKeyboardRef?.nativeElement;
    if (keyboardEl) {
      keyboardEl.scrollIntoView({ behavior: 'smooth', block: 'end' });
    } else {
      // Fallback: scroll chat container to bottom
      const scrollEl = this.chatScrollContainer?.nativeElement;
      if (scrollEl) {
        scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' });
      }
    }
  }

  insertSymbol(symbol: string): void {
    const control = this.chatForm.get('message');
    const textareaEl = this.messageInput?.nativeElement;

    if (control && textareaEl) {
      const currentValue = textareaEl.value || '';
      const start = textareaEl.selectionStart ?? currentValue.length;
      const end = textareaEl.selectionEnd ?? currentValue.length;

      const before = currentValue.slice(0, start);
      const after = currentValue.slice(end);
      const newValue = before + symbol + after;

      control.setValue(newValue);

      // Restore caret position after insertion
      setTimeout(() => {
        textareaEl.focus();
        const caret = start + symbol.length;
        textareaEl.selectionStart = caret;
        textareaEl.selectionEnd = caret;
        this.autoResizeTextarea();
      }, 0);
      return;
    }

    // Fallback: append at end
    if (control) {
      const currentValue = control.value || '';
      control.setValue(currentValue + symbol);
      setTimeout(() => this.autoResizeTextarea(), 0);
    }
  }

  autoResizeTextarea(): void {
    const el = this.messageInput?.nativeElement;
    if (!el) return;
    const minHeight = 80;
    const maxHeight = 200;
    el.style.height = 'auto';
    el.style.height = Math.max(minHeight, Math.min(el.scrollHeight, maxHeight)) + 'px';
  }

  scrollToBottom(force: boolean = false): void {
    if (!this.chatContent?.nativeElement) return;

    const el = this.chatContent.nativeElement;
    const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 50;

    if (force || isAtBottom) {
      this.isProgrammaticScroll = true;

      setTimeout(() => {
        el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });

        // Delay turning off programmatic flag to let smooth scroll finish
        setTimeout(() => {
          this.isProgrammaticScroll = false;
          console.log('✅ Finished programmatic scroll');
        }, 300); // 300ms or longer if your scroll is slow
      }, 0);
    }
  }








  ngAfterViewInit(): void {
    setTimeout(() => this.autoResizeTextarea(), 0);
  }

  ngAfterViewChecked() {
    if ((window as any).MathJax) {
      (window as any).MathJax.typesetPromise();
    }
    if (this.shouldScroll && this.autoScrollEnabled) {
      setTimeout(() => this.scrollToBottom(this.autoScrollEnabled), 0);
      this.shouldScroll = false;
    }
  }



  stripHtml(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }
  // playAudio(text: string): void {
  //   var sanitizedText = this.sanitizer.sanitize(SecurityContext.HTML, this.formatMessage(text));
  //   const plainText = this.stripHtml(sanitizedText as string);
  //   this.chatService.getAudio(plainText).then((audioUrl: string | null) => {
  //     if (audioUrl) {
  //       this.stopAudio(); // Stop any previous audio
  //       this.currentAudio = new Audio(audioUrl);
  //       this.playingMessageText = text; // Track currently playing message

  //       this.currentAudio.play()
  //         .then(() => {
  //           this.audioError = false;
  //           console.log("Audio started playing");
  //         })
  //         .catch(error => {
  //           console.error("Error playing audio:", error);
  //           this.audioError = true;
  //         });

  //       this.currentAudio.onended = () => {
  //         this.stopAudio(); // Stop audio when it finishes
  //       };
  //     } else {
  //       console.error("Failed to get audio URL.");
  //     }
  //   });
  // }


  // stopAudio(): void {
  //   if (this.currentAudio) {
  //     this.currentAudio.pause();
  //     this.currentAudio.currentTime = 0; // Reset
  //     this.currentAudio = null;
  //     this.playingMessageText = null; // Reset tracking
  //     console.log("Audio stopped");
  //   }
  // }
  toggleRevealing() {
    if (this.isRevealing) {
      this.stopRevealing();
    } else if (this.isTyping) {
      this.stopTyping();
    } else {
      this.sendMessage();
    }
  }

  stopTyping() {
    // Clear the timeout if it hasn't fired yet
    if (this.thinkingTimeout) {
      clearTimeout(this.thinkingTimeout);
      this.thinkingTimeout = null;
    }

    // Unsubscribe from the API request if it's active
    if (this.thinkingSubscription) {
      this.thinkingSubscription.unsubscribe();
      // this.thinkingSubscription = null;
    }

    this.isTyping = false;
    // Remove the last "user" message if we want to cancel the whole flow, 
    // OR just leave it and maybe show a "Cancelled" state. 
    // For now, let's just stop the indicator. 
    // The user might expect the prompt to disappear or stay. 
    // Usually, if you stop generation, the prompt stays.

    // Optionally remove the "thinking" indicator if it's separate, 
    // but isTyping=false handles that in the HTML usually.
  }

  // stopRevealing() {
  //   this.isRevealing = false; // Ensure state updates back to false
  // }
  PinChat(pinned: boolean) {
    const selectedChat = this.selectedChat;
    const sessionId = selectedChat?.sessionId;

    // if (!sessionId) {
    //   console.error('sessionId is undefined');
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'Missing Session ID',
    //     text: 'Unable to identify the chat session.',
    //   });
    //   return;
    // }

    // if (typeof selectedChat.pinned !== 'boolean') {
    //   console.error('Pinned state is invalid or missing');
    //   Swal.fire({
    //     icon: 'error',
    //     title: 'Invalid Data',
    //     text: 'Cannot determine current pinned state.',
    //   });
    //   return;
    // }
    // const sessionId = this.selectedChat.sessionId;
    const newPinnedState = !this._selectedChat.pinned;
    console.log('Pin status updated:', newPinnedState);
    this.chatService.pinSession(sessionId, newPinnedState).subscribe({
      next: (response: any) => {
        console.log('Pin status updated:', response);

        // selectedChat.pinned = newPinnedState; // update locally
        if (this.sessionId) {
          this.loadChatMessages(this.sessionId);
        }
        Swal.fire({
          icon: 'success',
          title: newPinnedState ? 'Pinned!' : 'Unpinned!',
          text: response.message || 'Chat session updated successfully.',
          timer: 2000,
          showConfirmButton: false,
        });

        this.chatService.triggerRefresh(); // optional UI refresh
      },
      error: (error) => {
        console.error('Error pinning session:', error);
        Swal.fire({
          icon: 'error',
          title: 'Update Failed',
          text: error?.error?.message || 'Something went wrong. Please try again later.',
        });
      }
    });
  }



  iconPathsByTheme: { [theme: string]: string[] } = {
    nebula_way: [
      'assets/icon/nebula/Suggestion_1.svg',
      'assets/icon/nebula/Suggestion_2.svg',
      'assets/icon/nebula/Suggestion_3.svg',
      'assets/icon/nebula/Suggestion_4.svg'
    ],
    spin_and_swing: [
      'assets/icon/cricket/Suggestion_1.svg',
      'assets/icon/cricket/Suggestion_2.svg',
      'assets/icon/cricket/Suggestion_3.svg',
      'assets/icon/cricket/Suggestion_4.svg'
    ],
    learning_lane: [
      'assets/icon/light/Suggestion_1.svg',
      'assets/icon/light/Suggestion_2.svg',
      'assets/icon/light/Suggestion_3.svg',
      'assets/icon/light/Suggestion_4.svg'
    ],
    cricket_fever: [
      'assets/icon/cricket2/Suggestion_1.svg',
      'assets/icon/cricket2/Suggestion_2.svg',
      'assets/icon/cricket2/Suggestion_3.svg',
      'assets/icon/cricket2/Suggestion_4.svg'
    ],
    camp_wings: [
      'assets/icon/camp/Suggestion_1.svg',
      'assets/icon/camp/Suggestion_2.svg',
      'assets/icon/camp/Suggestion_3.svg',
      'assets/icon/camp/Suggestion_4.svg'
    ]
  };
  // getTimeString(timestamp: string): string {
  //   const date = new Date(timestamp);
  //   return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); // e.g., "04:23 PM"
  // }
  groupMessagesByDate(): void {
    const groups: { [key: string]: any[] } = {};

    this.messages.forEach((msg) => {
      const date = new Date(msg.timestamp);
      const label = this.getDateLabel(date);

      if (!groups[label]) {
        groups[label] = [];
      }
      groups[label].push(msg);
    });

    // Convert to array for *ngFor
    this.groupedMessages = Object.keys(groups).map(label => ({
      label,
      messages: groups[label]
    }));
  }

  // 👇 Helper to generate "Today", "Yesterday", etc.
  getDateLabel(date: Date): string {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (
      date.toDateString() === today.toDateString()
    ) {
      return 'Today';
    } else if (
      date.toDateString() === yesterday.toDateString()
    ) {
      return 'Yesterday';
    } else {
      return date.toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    }
  }

  groupMessagesByDateHistory(messages: any[]): { date: string, messages: any[] }[] {
    const grouped: { [key: string]: any[] } = {};

    for (let msg of messages) {
      const dateKey = this.getDateGroupLabel(new Date(msg.timestamp));
      if (!grouped[dateKey]) {
        grouped[dateKey] = [];
      }
      grouped[dateKey].push(msg);
    }

    return Object.keys(grouped).map(date => ({
      date,
      messages: grouped[date]
    }));
  }

  getDateGroupLabel(date: Date): string {
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isToday = date.toDateString() === today.toDateString();
    const isYesterday = date.toDateString() === yesterday.toDateString();

    if (isToday) return 'Today';
    if (isYesterday) return 'Yesterday';

    return formatDate(date, 'd MMMM y', 'en-IN'); // e.g., 4 August 2025
  }

  getThemeMascot(): string {
    if (!this.enableStudentThemes) {
      return 'default';
    }
    return getStudentThemeVisual(this.normalizedThemeName).mascot;
  }
  // @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  // scrollToBottom(): void {
  //   try {
  //     this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
  //   } catch (err) {}
  // }
    isDarkTheme(): boolean {
    return this.themeService.getCurrentTheme();
  }
}
